// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Extra large devices (large desktops, 1800px and up) */
@media (max-width: 1800px) {
  .faq-shape-wrap img:nth-child(2) {
    left: 9%;
  }
  .banner-shape {
    left: 8%;
  }
  .about-shape-wrap-two img:nth-child(1) {
    left: 11%;
  }
}

/* Extra large devices (large desktops, 1800px and up) */
@media (max-width: 1500px) {
  .container {
    max-width: 1250px;
  }
  .slider-shape {
    left: 4%;
  }
  .slider-bg {
    min-height: 670px;
  }
  .slider-content .title {
    font-size: 55px;
  }
  .faq-shape-wrap img:nth-child(2) {
    left: 7%;
    bottom: 47%;
  }
  .about-shape-wrap-two img:nth-child(1) {
    left: 3%;
  }
  .about-shape-wrap-two img:nth-child(2) {
    left: 36%;
  }
  .about-shape-wrap-two img:nth-child(3) {
    width: 380px;
  }
  .choose-shape img {
    width: 300px;
  }
  .pricing-shape img {
    width: 300px;
  }
  .request-shape-wrap img:nth-child(1) {
    left: 3%;
  }
  .banner-content-two .title {
    font-size: 55px;
  }
  .banner-shape-wrap img:nth-child(3) {
    right: 19%;
  }
  .banner-area-three {
    padding: 120px 0 60px;
  }
  .banner-content-three .title {
    font-size: 56px;
  }
  .overview-img-two .img-two {
    left: -8%;
  }
  .about-img-wrap-five img:nth-child(2) {
    left: -11%;
  }
  .about-shape-five img {
    left: 34%;
  }
  .banner-content-four .title {
    font-size: 55px;
  }
  .banner-area-five {
    padding: 115px 0 80px;
  }
  .breadcrumb-bg {
    padding: 110px 0 120px;
  }
  .about-img-wrap-ten img:nth-child(2) {
    left: 0;
  }
  .error-area {
    padding: 120px 0;
  }
  .error-content .error-404 {
    font-size: 350px;
  }
}

/* Narrow desktop only: below 992px mobile.css owns the logo size. */
@media (min-width: 992px) and (max-width: 1199.98px) {
  .menu-area .logo img {
    max-height: 38px !important;
  }
}

/* Extra large devices (large desktops, 1200px and up) */
@media (max-width: 1199.98px) {
  .container,
  .custom-container {
    max-width: 960px;
  }
  /* The row no longer wraps, so on the narrowest desktop the nav and the
     account block have to share a tighter budget rather than spill over. The
     container is 960px here and seven nav items plus a signed-in account block
     do not both fit at full size, so the name gives way to the avatar (which
     still links to the profile) and the logo comes down a few pixels. */
  .navbar-wrap ul li a {
    padding: 20px 10px;
    font-size: 15px;
  }
  .header-action > ul {
    margin-left: 15px;
  }
  .header-action > ul li {
    margin-left: 15px;
  }
  .header-profile-name {
    display: none;
  }
  .slider-content .title {
    font-size: 50px;
  }
  .slider-content p {
    margin-bottom: 30px;
    width: 100%;
  }
  .slider-shape {
    left: 4%;
    bottom: 7%;
  }
  .slider-bg {
    min-height: 590px;
    padding: 170px 0 100px;
  }
  .about-content {
    width: 100%;
  }
  .section-title .title {
    font-size: 36px;
  }
  .about-img-wrap img:nth-child(3) {
    right: 8%;
  }
  .features-item {
    padding: 35px 25px;
  }
  .about-img-two {
    padding-left: 75px;
  }
  .about-img-two img:nth-child(2) {
    border: 5px solid #ffffff;
    left: 0;
    max-width: 215px;
  }
  .about-shape-wrap img:nth-child(1) {
    right: 45%;
  }
  .success-wrap .list-wrap li .count {
    font-size: 32px;
  }
  .about-list .list-wrap li {
    font-size: 16px;
  }
  .services-content .content-top .title {
    font-size: 22px;
  }
  .services-item {
    padding: 25px 25px 35px;
  }
  .services-content .list-wrap li {
    align-items: baseline;
  }
  .counter-item .count {
    font-size: 50px;
  }
  .faq-content > p {
    width: 100%;
  }
  .faq-content .accordion-wrap {
    width: 100%;
  }
  .faq-img-wrap {
    margin-right: 0;
  }
  .faq-shape-wrap img:nth-child(2) {
    left: 0;
  }
  .request-content .title {
    font-size: 30px;
  }
  .request-content .title br {
    display: none;
  }
  .testimonial-content {
    width: 100%;
  }
  .pricing-box {
    padding: 40px 25px;
  }
  .contact-form {
    margin: 0;
  }
  .blog-post-content .title {
    font-size: 20px;
  }
  .blog-post-content {
    padding: 25px 22px 30px;
  }
  .blog-post-thumb img {
    min-height: 225px;
    object-fit: cover;
  }
  .footer-newsletter p {
    width: 100%;
  }
  .footer-widget .fw-title {
    font-size: 22px;
  }
  .footer-info .list-wrap li .content p br {
    display: none;
  }
  .footer-bottom {
    padding: 40px 0;
  }
  .header-style-two .header-action > ul li.header-contact-two {
    display: none;
  }
  .banner-content-two .title {
    font-size: 50px;
  }
  .banner-content-two {
    width: 100%;
  }
  .banner-shape-wrap img:nth-child(1) {
    left: 51%;
    bottom: 51%;
  }
  .banner-shape-wrap img:nth-child(2) {
    right: 39%;
  }
  .banner-shape-wrap img:nth-child(3) {
    right: 13%;
    width: 400px;
  }
  .banner-area-two .banner-img.text-center {
    text-align: right !important;
  }
  .banner-area-two .banner-img img {
    max-width: 380px;
  }
  .banner-bg-two {
    min-height: 700px;
  }
  .features-content-two p {
    width: 100%;
  }
  .section-title-two .title {
    font-size: 36px;
  }
  .about-img-wrap-three img:nth-child(1) {
    border-radius: 80px 0 0 0;
    max-width: 380px;
  }
  .about-img-wrap-three img:nth-child(2) {
    border: 5px solid var(--tg-white);
    bottom: 20%;
    width: 200px;
    right: -10px;
  }
  .about-img-wrap-three .experience-wrap {
    width: auto;
    border-radius: 0px 0px 0px 35px;
    padding: 30px 185px 30px 20px;
  }
  .about-img-wrap-three .experience-wrap .title {
    font-size: 40px;
  }
  .about-img-wrap-three .experience-wrap .title span {
    font-size: 18px;
  }
  .about-shape-wrap-two img:nth-child(1) {
    left: 1%;
  }
  .about-shape-wrap-two img:nth-child(2) {
    left: 33%;
    top: 10%;
  }
  .about-content-three p {
    width: 100%;
  }
  .about-shape-wrap-two img:nth-child(3) {
    width: 340px;
  }
  .overview-content {
    width: 100%;
  }
  .content-bottom .list-wrap li {
    padding: 28px 15px 28px 20px;
    min-width: 200px;
  }
  .content-bottom .list-wrap li .icon {
    font-size: 36px;
    margin-right: 30px;
  }
  .content-bottom .list-wrap li .icon::after {
    right: -15px;
  }
  .content-bottom .list-wrap li .content .count {
    font-size: 30px;
  }
  .skill-wrap {
    padding: 60px 35px;
    margin-left: 0;
  }
  .choose-content {
    width: 100%;
  }
  .project-content-top p {
    width: 100%;
  }
  .project-content-two .title {
    font-size: 24px;
  }
  .project-content-two {
    padding: 20px;
  }
  .project-content-two .link-btn {
    right: 20px;
    bottom: 20px;
  }
  .cta-inner-wrap {
    padding: 70px 30px;
  }
  .cta-info-wrap .icon {
    font-size: 35px;
  }
  .cta-info-wrap .content a {
    font-size: 26px;
  }
  .cta-info-wrap::before {
    right: 38px;
    height: 66px;
  }
  .section-top-content p {
    width: 100%;
  }
  .testimonial-item-two {
    padding: 30px 30px;
  }
  .testimonial-nav-two .slick-arrow {
    left: -30px;
  }
  .testimonial-nav-two .slick-arrow.slick-next {
    left: auto;
    right: -30px;
  }
  .pricing-head-two {
    padding: 40px 25px 40px;
  }
  .pricing-price-two .price {
    font-size: 35px;
  }
  .pricing-bottom {
    padding: 30px 25px 40px;
  }
  .pricing-box-two .popular {
    top: 45px;
  }
  .blog-post-content-two {
    padding: 35px 20px;
  }
  .blog-post-content-two .title {
    font-size: 22px;
  }
  .footer-top-two .footer-info .list-wrap li .content p br {
    display: block;
  }
  .footer-top-two .footer-content > p {
    width: 100%;
  }
  .banner-img-three {
    padding-right: 0;
  }
  .banner-img-three img.main-img {
    max-width: 410px;
  }
  .about-img-wrap-four {
    margin-right: 0;
  }
  .mask-img-wrap {
    height: auto;
    width: 100%;
  }
  .mask-img-wrap img {
    max-width: unset;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .overview-img-two .img-two {
    left: -4%;
  }
  .mask-img-two {
    height: auto;
    width: 100%;
  }
  .banner-img-three img.img-three {
    right: -1%;
    top: 17%;
  }
  .banner-content-three .banner-form {
    width: 100%;
  }
  .header-contact-two {
    margin-right: 0;
  }
  .header-style-three .header-action > ul {
    margin-left: 30px;
  }
  .features-item-wrap-two
    .row
    [class*="col-"]:nth-child(even)
    .features-item-three {
    margin-top: 0;
  }
  .about-list-three .content p {
    width: 100%;
  }
  .about-img-wrap-four .icon {
    width: 90px;
    height: 90px;
    left: -1%;
    top: 11%;
    font-size: 40px;
  }
  .about-shape-wrap-three img:nth-child(1) {
    top: 8%;
    width: 475px;
  }
  .about-shape-wrap-three img:nth-child(2) {
    left: 2%;
    bottom: 6%;
  }
  .about-shape-wrap-three img:nth-child(3) {
    right: 31%;
    top: -3%;
  }
  .mask-img-two img {
    max-width: unset;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .overview-content-two {
    margin-left: 0;
  }
  .overview-shape-wrap img:nth-child(1) {
    right: 0%;
    top: 8%;
  }
  .overview-shape-wrap img:nth-child(2) {
    right: 0%;
    top: 23%;
  }
  .counter-item-two .count {
    font-size: 45px;
  }
  .team-thumb-three::before {
    right: -63px;
    bottom: -32px;
  }
  .testimonial-item-wrap-three {
    padding: 32px 40px;
  }
  .testimonial-nav-three {
    left: auto;
    bottom: 14%;
    right: 25%;
  }
  .cta-inner-wrap-two {
    padding: 70px 30px;
  }
  .section-title-two p {
    width: 100%;
  }
  .banner-content-four {
    margin-top: 20px;
  }
  .banner-content-four .title {
    font-size: 50px;
  }
  .banner-content-four p {
    margin-bottom: 20px;
    width: 100%;
  }
  .banner-bg-four {
    padding: 60px 0 30px;
  }
  .banner-shape-wrap-four img:nth-child(3) {
    right: 4%;
  }
  .banner-shape-wrap-four img:nth-child(2) {
    right: 35%;
  }
  .banner-shape-wrap-four img:nth-child(1) {
    left: 26%;
    bottom: 27%;
  }
  .features-item-wrap-four {
    padding: 50px 25px 20px;
  }
  .features-icon-four {
    width: 70px;
    height: 70px;
  }
  .about-content-five {
    margin-left: 0;
    width: 100%;
  }
  .about-content-five > p {
    margin-bottom: 40px;
    width: 100%;
  }
  .about-success-wrap .list-wrap li .content .count {
    font-size: 40px;
  }
  .about-success-wrap .list-wrap li .icon {
    font-size: 50px;
    margin-right: 15px;
  }
  .about-img-wrap-five .experience-wrap .title {
    font-size: 50px;
  }
  .about-img-wrap-five img:nth-child(2) {
    left: -23px;
  }
  .about-shape-five img {
    left: 39%;
  }
  .choose-content-two {
    width: 100%;
  }
  .choose-content-two > p {
    width: 100%;
  }
  .choose-img-two img:nth-child(2) {
    right: 2%;
    top: 0%;
  }
  .choose-img-two img:nth-child(3) {
    right: 0%;
    top: 28%;
  }
  .cta-inner-wrap-three {
    padding: 50px 25px;
  }
  .estimate-content {
    padding: 0;
  }
  .testimonial-item-wrap-four {
    padding-right: 90px;
  }
  .pricing-box-three {
    padding: 40px 25px 40px;
  }
  .blog-post-content-four {
    padding: 40px 25px 30px;
  }
  .blog-post-content-four .title {
    font-size: 20px;
  }
  .blog-post-content-four .tag {
    left: 20px;
  }
  .banner-img-five {
    margin-left: 0;
  }
  .banner-img-five .main-img {
    width: 650px;
  }
  .banner-img-five .shape-one {
    right: -14%;
    bottom: 14%;
  }
  .banner-content-five .title {
    font-size: 45px;
  }
  .banner-area-five::after {
    right: -47%;
    top: -14%;
  }
  .section-title-three p {
    width: 100%;
  }
  .services-item-four {
    padding: 40px 25px 45px;
  }
  .about-img-six img:nth-child(1) {
    max-width: 100%;
  }
  .about-img-six {
    margin-left: 0;
  }
  .about-content-six {
    width: 100%;
  }
  .testimonial-content-five {
    padding-right: 70px;
  }
  .testimonial-nav-five {
    right: -90px;
  }
  .testimonial-img-five .shape-one {
    left: -2%;
  }
  .testimonial-img-five .shape-two {
    left: 7%;
  }
  .testimonial-img-five .shape-three {
    left: 2%;
  }
  .about-content-seven {
    width: 100%;
  }
  .success-wrap-two .list-wrap li {
    padding: 30px 20px;
    min-width: 206px;
  }
  .success-wrap-two .list-wrap li .icon {
    font-size: 40px;
    margin-right: 15px;
  }
  .success-wrap-two .list-wrap li .content .count {
    font-size: 34px;
  }
  .about-img-seven-wrap img:nth-child(1) {
    width: 390px;
  }
  .about-img-seven-wrap .experience-wrap .title {
    font-size: 50px;
  }
  .about-img-seven-wrap .experience-wrap p {
    font-size: 20px;
  }
  .about-img-seven-wrap .experience-wrap {
    min-height: 370px;
  }
  .about-img-seven-wrap .shape {
    left: 18%;
  }
  .about-content-eight .right-slide-img {
    width: 40%;
  }
  .about-content-eight .about-content-inner .list-wrap li .icon {
    width: 60px;
    height: 60px;
    font-size: 30px;
    border-radius: 10px;
    margin-right: 10px;
  }
  .about-content-eight .about-content-bottom {
    gap: 30px 25px;
  }
  .about-content-eight .about-content-inner {
    margin-bottom: 30px;
  }
  .choose-content-three {
    margin-right: 0px;
  }
  .choose-img-three {
    width: 45%;
  }
  .counter-item-wrap-four .counter-item-three {
    padding: 28px 20px;
  }
  .counter-item-wrap-four .counter-icon {
    font-size: 45px;
    margin-right: 30px;
  }
  .counter-item-wrap-four .counter-content .count {
    font-size: 32px;
  }
  .counter-item-wrap-four .counter-icon::after {
    right: -15px;
  }
  .counter-item-wrap-four .counter-content p {
    font-size: 14px;
  }
  .counter-content-four {
    width: 100%;
  }
  .about-content-five.about-content-ten {
    margin: 0;
  }
  .about-img-wrap-ten img:nth-child(2) {
    left: 0;
  }
  .about-area-ten .about-shape-five img {
    left: 41%;
  }
  .features-content-seven {
    width: 100%;
  }
  .features-progress-wrap {
    width: 100%;
  }
  .about-content-eleven {
    width: 100%;
  }
  .about-img-wrap-eleven .shape-two {
    left: -32px;
    max-width: 115%;
  }
  .services-sidebar {
    padding-right: 0;
  }
  .services-details-area .row .col-29 {
    width: 32%;
  }
  .services-details-area .row .col-71 {
    width: 68%;
  }
  .services-widget {
    padding: 30px 20px 35px;
  }
  .services-details-content .title {
    font-size: 30px;
  }
  .services-details-content .title-two {
    font-size: 24px;
  }
  .services-cat-list .list-wrap li a {
    padding: 15px 16px;
  }
  .sd-inner-wrap-two .row .col-58 {
    width: 50%;
  }
  .sd-inner-wrap-two .row .col-42 {
    width: 50%;
  }
  .services-details-list .list-wrap li {
    margin-bottom: 30px;
  }
  .services-details-list .list-wrap li .icon {
    width: 60px;
    height: 60px;
    border-radius: 10px;
    font-size: 30px;
    margin-right: 10px;
  }
  .services-details-list-two {
    margin-right: 0;
  }
  .services-details-list-two .list-wrap li {
    padding: 20px 15px;
    display: block;
  }
  .services-details-list-two .list-wrap li .icon {
    margin-right: 0;
    margin-bottom: 10px;
  }
  .sd-inner-wrap-four .row .col-55 {
    width: 50%;
  }
  .sd-inner-wrap-four .row .col-45 {
    width: 50%;
  }
  .services-details-list-three .list-wrap li {
    padding: 25px 20px;
  }
  .sd-inner-wrap-five .left-side-content {
    margin-right: 0;
  }
  .project-details-wrap .row .col-29 {
    width: 35%;
  }
  .project-details-wrap .row .col-71 {
    width: 65%;
  }
  .project-details-info {
    padding: 25px 20px 28px;
  }
  .project-details-thumb img {
    min-height: 440px;
    object-fit: cover;
  }
  .project-details-content .title {
    font-size: 30px;
  }
  .project-details-content .title-two {
    font-size: 24px;
  }
  .pd-inner-wrap .content {
    margin-right: 0;
  }
  .pd-inner-wrap .row .col-41 {
    width: 50%;
  }
  .pd-inner-wrap .row .col-59 {
    width: 50%;
  }
  .team-details-info-wrap {
    margin-right: 0;
  }
  .team-details-content > .title {
    font-size: 30px;
  }
  .team-skill-wrap > .title-two {
    font-size: 24px;
  }
  .blog-sidebar {
    margin-left: 0;
  }
  .inner-blog-wrap .row .col-29 {
    width: 32%;
  }
  .inner-blog-wrap .row .col-71 {
    width: 68%;
  }
  .blog-widget {
    padding: 25px 20px 30px;
  }
  .blog-post-thumb-two img {
    min-height: 200px;
    object-fit: cover;
  }
  .blog-details-wrap .row .col-29 {
    width: 32%;
  }
  .blog-details-wrap .row .col-71 {
    width: 68%;
  }
  .blog-details-content > .title {
    font-size: 30px;
  }
  .blog-details-content blockquote {
    margin: 50px 0 60px;
    padding: 50px 100px 50px 35px;
  }
  .blog-details-content .title-two {
    font-size: 24px;
  }
  .blog-avatar-wrap {
    padding: 35px 25px;
  }
  .comment-respond {
    padding: 35px 25px 50px;
  }
  .inner-contact-info {
    padding-left: 40px;
  }
  .inner-contact-info .title {
    font-size: 32px;
  }
  .contact-info-item {
    margin-bottom: 30px;
  }
  .contact-map {
    height: 400px;
  }
  .error-content .error-404 {
    font-size: 300px;
  }
}

/* Large devices (desktops, 992px and up) */
@media (max-width: 991.98px) {
  .container,
  .custom-container {
    max-width: 720px;
  }
  .menu-area {
    padding: 18px 0;
  }
  .menu-nav {
    justify-content: space-between;
  }
  .header-action {
    margin-right: 30px;
  }
  .menu-outer .navbar-wrap {
    display: block !important;
  }
  .menu-area .mobile-nav-toggler {
    display: block;
  }
  .header-top-left .list-wrap li::before {
    height: 25px;
  }
  .header-top-left .list-wrap {
    justify-content: center;
    margin-bottom: 10px;
  }
  .header-top-right {
    justify-content: center;
  }
  .header-contact::before {
    height: 25px;
  }
  .slider-content {
    text-align: center;
  }
  .slider-content .sub-title::before {
    left: 50%;
    transform: translateX(-50%);
  }
  .slider-bg {
    min-height: 620px;
    padding: 210px 0 80px;
    background-position: left center;
  }
  .about-img-wrap {
    margin-bottom: 50px;
  }
  .section-title .title {
    font-size: 34px;
  }
  .about-img-two {
    margin-bottom: 50px;
  }
  .about-shape-wrap img:nth-child(1) {
    right: auto;
    left: 16%;
  }
  .about-list .list-wrap li {
    font-size: 18px;
  }
  .success-wrap .list-wrap li .count {
    font-size: 34px;
  }
  .project-top-content {
    margin-left: 0;
    margin-bottom: 40px;
  }
  .swiper-container.project-active {
    margin-right: -285px;
  }
  .faq-bg-shape {
    display: none;
  }
  .faq-img-wrap {
    margin-bottom: 50px;
  }
  .faq-shape-wrap img:nth-child(2) {
    display: none;
  }
  .request-content .title {
    font-size: 28px;
  }
  .request-content {
    text-align: center;
    margin-bottom: 30px;
  }
  .request-content-right {
    justify-content: center;
  }
  .team-thumb img {
    width: 100%;
  }
  .testimonial-content {
    text-align: center;
  }
  .testimonial-info span::before {
    left: 50%;
    transform: translateX(-50%);
  }
  .testimonial-nav {
    justify-content: center;
    left: calc(50% - 50px);
  }
  .contact-content {
    margin-bottom: 50px;
  }
  .contact-bg {
    background-position: left;
  }
  .footer-top .row [class*="col-"]:nth-child(3) .footer-widget {
    margin-left: 0;
  }
  .testimonial-img {
    margin-bottom: 50px;
  }
  .header-style-two .heder-top-wrap {
    display: none;
  }
  .header-style-two .menu-area {
    padding: 0;
  }
  .header-style-two {
    background: var(--tg-white);
  }
  .header-style-two .header-action > ul li.offcanvas-menu {
    display: none;
  }
  .header-style-two .header-action ul > li > a {
    border-right: 1px solid #d9d9d9;
  }
  .header-style-two .menu-area .mobile-nav-toggler {
    margin-top: 20px;
  }
  .banner-content-two {
    text-align: center;
    margin-bottom: 50px;
  }
  .banner-content-two .banner-btn {
    justify-content: center;
  }
  .banner-area-two .banner-img.text-center {
    text-align: center !important;
  }
  .banner-area-two .banner-img img {
    max-width: 350px;
  }
  .banner-shape-wrap img:nth-child(1) {
    left: 21%;
    bottom: 41%;
  }
  .banner-shape-wrap img:nth-child(2) {
    right: auto;
    left: 26%;
  }
  .banner-shape-wrap img:nth-child(3) {
    right: 38%;
    width: 386px;
  }
  .banner-bg-two {
    padding: 150px 0 0;
  }
  .about-img-wrap-three .experience-wrap {
    width: 90%;
  }
  .about-img-wrap-three img:nth-child(2) {
    right: 0;
  }
  .about-img-wrap-three {
    padding-bottom: 70px;
    margin-bottom: 50px;
  }
  .about-shape-wrap-two img:nth-child(1) {
    left: 14%;
    bottom: auto;
    top: 29%;
  }
  .about-shape-wrap-two img:nth-child(2) {
    left: auto;
    top: 2%;
    right: 16%;
  }
  .section-title-two .title {
    font-size: 34px;
  }
  .overview-img-wrap {
    margin-bottom: 50px;
  }
  .content-bottom .list-wrap li {
    min-width: 250px;
  }
  .content-bottom .list-wrap li .icon {
    font-size: 45px;
  }
  .content-bottom .list-wrap li .content .count {
    font-size: 34px;
  }
  .choose-content {
    text-align: center;
    margin-bottom: 50px;
  }
  .skill-wrap {
    padding: 60px 60px;
  }
  .project-area-two .section-title-two {
    text-align: center;
    margin-bottom: 20px;
  }
  .project-content-top p {
    text-align: center;
  }
  .cta-btn.text-end {
    text-align: center !important;
  }
  .cta-content {
    margin-bottom: 40px;
    justify-content: center;
  }
  .cta-content .title {
    font-size: 26px;
  }
  .cta-inner-wrap {
    padding: 60px 30px;
  }
  .team-area-two .section-title-two {
    text-align: center;
    margin-bottom: 20px;
  }
  .section-top-content {
    text-align: center;
  }
  .team-thumb-two img {
    width: 100%;
  }
  .pricing-area-two .section-title-two {
    text-align: center;
    margin-bottom: 20px;
  }
  .blog-bg-two {
    background-position: left;
  }
  .section-title-two p {
    width: 80%;
  }
  .request-content-two {
    text-align: center;
    margin-bottom: 50px;
  }
  .request-content-two p {
    width: 80%;
    margin: 0 auto;
  }
  .footer-top-two .footer-info .list-wrap li .content p br {
    display: none;
  }
  .banner-img-three {
    text-align: center;
  }
  .banner-content-three {
    margin-top: 50px;
    text-align: center;
  }
  .banner-shape-wrap-three img:nth-child(2) {
    right: 13%;
    top: 39%;
    bottom: auto;
  }
  .banner-img-three img.img-two {
    left: 0%;
  }
  .banner-content-three .title {
    font-size: 50px;
  }
  .banner-shape-wrap-three img:nth-child(1) {
    right: auto;
    bottom: auto;
    top: 26%;
    left: 10%;
  }
  .about-img-wrap-four {
    margin-bottom: 50px;
  }
  .overview-img-two {
    margin-bottom: 50px;
  }
  .counter-item-two::before {
    display: none;
  }
  .team-thumb-three img {
    width: 100%;
  }
  .team-thumb-three::before {
    right: -88px;
    bottom: -45px;
    width: 250px;
    height: 560px;
    border-radius: 180px;
  }
  .testimonial-img-three {
    display: none;
  }
  .testimonial-area-three .row .col-63 {
    width: 100%;
  }
  .testimonial-item-wrap-three {
    padding: 40px 40px;
  }
  .testimonial-item-wrap-three .testimonial-info span::before {
    left: 0;
    transform: translateX(0);
  }
  .cta-inner-wrap-two {
    padding: 60px 30px;
  }
  .header-style-three .offcanvas-menu.offcanvas-menu-two {
    display: none;
  }
  .header-style-three .menu-area .mobile-nav-toggler {
    margin-top: -1px;
  }
  .header-style-four .header-top-right {
    display: none;
  }
  .header-style-four .header-top-left .list-wrap {
    margin-bottom: 0;
  }
  .header-style-four .heder-top-wrap {
    padding: 15px 0;
  }
  .header-style-four .offcanvas-menu.offcanvas-menu-two {
    display: none;
  }
  .header-style-four .menu-area .mobile-nav-toggler {
    margin-top: -1px;
  }
  .banner-shape-wrap-four img:nth-child(3) {
    right: 16%;
    width: 300px;
  }
  .banner-shape-wrap-four img:nth-child(2) {
    right: auto;
    left: 10%;
    bottom: auto;
    top: 27%;
  }
  .banner-content-four {
    margin-top: 50px;
    text-align: center;
  }
  .banner-bg-four {
    padding: 60px 0 140px;
  }
  .about-shape-five img {
    left: auto;
    right: 18%;
    bottom: auto;
    top: 33%;
  }
  .about-img-wrap-five {
    margin-bottom: 50px;
  }
  .choose-content-two {
    text-align: center;
    margin-top: 50px;
  }
  .choose-circle-wrap {
    justify-content: center;
  }
  .estimate-content {
    margin-bottom: 50px;
  }
  .team-thumb-four img {
    width: 100%;
  }
  .testimonial-img-four::before {
    left: 11.2%;
  }
  .testimonial-img-four {
    margin-bottom: 50px;
  }
  .pricing-area-three .section-title-two {
    text-align: center;
    margin-bottom: 30px;
  }
  .banner-content-five {
    text-align: center;
    margin-top: 50px;
  }
  .about-img-six img:nth-child(2) {
    bottom: -7%;
  }
  .about-img-six {
    margin-bottom: 50px;
  }
  .project-thumb-four > img {
    min-height: 290px;
    width: 100%;
    object-fit: cover;
  }
  .testimonial-content-five .testimonial-content {
    text-align: left;
  }
  .testimonial-img-five {
    margin-bottom: 50px;
  }
  .about-img-seven-wrap {
    margin-bottom: 50px;
  }
  .success-wrap-two .list-wrap li {
    padding: 30px 25px;
    min-width: 240px;
  }
  .success-wrap-two .list-wrap li .icon {
    font-size: 45px;
  }
  .success-wrap-two .list-wrap li .content .count {
    font-size: 36px;
  }
  .breadcrumb-bg {
    padding: 90px 0 100px;
  }
  .breadcrumb-content .title {
    font-size: 40px;
  }
  .brand-area-six {
    padding: 60px 0;
  }
  .about-img-eight {
    margin-bottom: 50px;
  }
  .about-content-eight .right-slide-img {
    width: auto;
  }
  .about-content-eight .about-content-inner {
    margin-bottom: 40px;
  }
  .choose-img-three {
    display: none;
  }
  .about-content-eight .about-content-inner .list-wrap li .icon {
    width: 80px;
    height: 80px;
    font-size: 40px;
    margin-right: 15px;
  }
  .counter-item-wrap-four .counter-item-three {
    padding: 28px 30px;
  }
  .counter-item-wrap-four .counter-icon {
    font-size: 60px;
    margin-right: 40px;
  }
  .counter-item-wrap-four .counter-content .count {
    font-size: 36px;
  }
  .counter-item-wrap-four .counter-content p {
    font-size: 16px;
  }
  .counter-item-wrap-four .counter-icon::after {
    right: -20px;
  }
  .counter-content-four {
    margin-bottom: 50px;
  }
  .about-img-wrap-ten {
    padding-left: 25px;
  }
  .about-area-ten .about-shape-five img {
    left: 16%;
  }
  .features-content-seven {
    margin-bottom: 50px;
  }
  .about-content-eleven {
    margin-top: 50px;
  }
  .section-title .title br {
    display: none;
  }
  .about-content-six {
    margin-top: 50px;
  }
  .services-area-six .section-title-two {
    text-align: center;
    margin-bottom: 30px;
  }
  .services-details-area .row .col-71 {
    width: 100%;
  }
  .services-details-area .row .col-29 {
    width: 70%;
  }
  .services-sidebar {
    margin-top: 120px;
  }
  .services-widget {
    padding: 30px 30px 35px;
  }
  .brand-area-seven {
    padding: 50px 0;
  }
  .sd-inner-wrap-two .row .col-42 {
    width: 45%;
  }
  .sd-inner-wrap-two .row .col-58 {
    width: 55%;
  }
  .services-details-list-two .list-wrap li {
    padding: 20px;
  }
  .sd-inner-wrap-four .row .col-55 {
    width: 100%;
  }
  .sd-inner-wrap-four .thumb {
    margin-bottom: 30px;
  }
  .sd-inner-wrap-four .thumb img {
    width: 100%;
    max-height: 400px;
    object-fit: cover;
  }
  .sd-inner-wrap-four .row .col-45 {
    width: 100%;
  }
  .services-details-list-three .list-wrap li .content .title {
    font-size: 20px;
  }
  .project-details-wrap .row .col-71 {
    width: 100%;
  }
  .project-details-wrap .row .col-29 {
    width: 100%;
  }
  .project-details-info {
    padding: 25px 35px 28px;
  }
  .pd-inner-wrap .row .col-41 {
    width: 100%;
  }
  .pd-inner-wrap .row .col-59 {
    width: 100%;
  }
  .pd-inner-wrap .content {
    margin-bottom: 30px;
  }
  .team-details-info-wrap {
    margin-bottom: 50px;
  }
  .team-details-thumb {
    text-align: center;
  }
  .inner-blog-wrap .row .col-71 {
    width: 100%;
  }
  .blog-post-thumb-two img {
    min-height: 230px;
  }
  .inner-blog-wrap .row .col-29 {
    width: 70%;
  }
  .blog-sidebar {
    margin-top: 120px;
  }
  .blog-widget {
    padding: 25px 30px 30px;
  }
  .blog-details-wrap .row .col-29 {
    width: 70%;
  }
  .blog-details-wrap .row .col-71 {
    width: 100%;
  }
  .inner-contact-img {
    text-align: center;
    margin-bottom: 50px;
  }
  .inner-contact-info {
    padding-left: 0;
  }
}

/* Medium devices (tablets, 768px and up) */
@media (max-width: 767.98px) {
  .custom-container {
    max-width: 100%;
  }
  .transparent-header {
    top: 0;
  }
  .header-spacer {
    height: 70px !important;
  }
  .about-area-two::before {
    display: none;
  }
  .header-top-left {
    display: none;
  }
  .menu-area {
    padding: 20px 0;
  }
  .menu-area .mobile-nav-toggler {
    margin-top: -6px;
  }
  .slider-content .title {
    font-size: 42px;
  }
  .slider-bg {
    min-height: 550px;
    padding: 180px 0 80px;
  }
  .about-img-wrap img.main-img {
    width: 260px;
    height: 260px;
  }
  .about-bg {
    padding: 100px 0 180px;
  }
  .section-title .title {
    font-size: 32px;
  }
  .about-img-two img:nth-child(2) {
    display: none;
  }
  .about-img-two .main-img img {
    border-radius: 15px;
    border: 6px solid var(--tg-white);
    width: 100%;
  }
  .about-area-two {
    padding: 90px 0 100px;
  }
  .about-img-two {
    padding-left: 0;
  }
  .about-shape-wrap img:nth-child(1) {
    display: none;
  }
  .about-list .list-wrap li {
    width: 100%;
  }
  .success-wrap .list-wrap li {
    width: 100%;
  }
  .success-wrap .list-wrap {
    flex-wrap: wrap;
    gap: 30px;
  }
  .about-area-two {
    padding: 70px 0 100px;
  }
  .services-thumb img {
    width: 100%;
  }
  .services-item {
    padding: 25px 20px 35px;
  }
  .section-title .title br {
    display: none;
  }
  .services-bg {
    padding: 100px 0;
  }
  .counter-bg {
    padding: 100px 0 70px;
  }
  .counter-item .count {
    font-size: 45px;
  }
  .project-bg {
    padding: 100px 0 70px;
  }
  .swiper-container.project-active {
    margin-right: 0;
  }
  .project-thumb img {
    width: 100%;
  }
  .project-content {
    margin: -85px 15px 0;
    padding: 22px 70px 22px 18px;
  }
  .project-content .title {
    font-size: 20px;
  }
  .faq-img-wrap img:nth-child(2) {
    bottom: 27%;
    width: 180px;
  }
  .faq-content .accordion-button {
    padding: 17px 50px 17px 20px;
  }
  .faq-content .accordion-body {
    padding: 20px 20px 30px;
  }
  .faq-area {
    padding: 0 0 100px;
  }
  .request-content .title {
    font-size: 25px;
  }
  .request-content-right {
    flex-wrap: wrap;
  }
  .team-bg {
    padding: 100px 0 70px;
  }
  .testimonial-img .review-wrap {
    max-width: 150px;
    border-radius: 10px;
    padding: 10px 10px 10px;
    left: 0;
  }
  .testimonial-img .review-wrap img {
    margin-bottom: 10px;
  }
  .testimonial-img .review-wrap .content .title {
    font-size: 30px;
  }
  .testimonial-nav {
    bottom: 24px;
  }
  .testimonial-bg {
    padding: 100px 0;
    background-position: center;
  }
  .pricing-area {
    padding: 100px 0 70px;
  }
  .section-title.text-center.mb-60 {
    margin-bottom: 40px;
  }
  .contact-bg {
    padding: 100px 0;
  }
  .blog-post-area {
    padding: 100px 0 70px;
  }
  .brand-aera {
    padding-bottom: 80px;
  }
  .footer-top {
    padding: 80px 0 30px;
  }
  .footer-bottom {
    padding: 20px 0;
  }
  .footer-bottom .left-sider {
    text-align: center;
    margin-bottom: 15px;
  }
  .footer-social .list-wrap {
    justify-content: center;
  }
  .footer-social .list-wrap li a {
    width: 40px;
    height: 40px;
    font-size: 16px;
  }
  .scroll-top {
    right: 15px;
  }
  .section-title p br {
    display: none;
  }
  .testimonial-nav-two {
    display: none;
  }
  .header-style-two .header-action ul > li > a {
    padding: 0;
    border: none;
  }
  .header-style-two .header-action > ul li::before {
    display: none;
  }
  .search-wrap .title {
    font-size: 34px;
    margin: 0 0 30px 0;
  }
  .search-form input {
    padding: 10px 30px 10px;
    font-size: 20px;
  }
  .search-btn {
    right: 10px;
    font-size: 20px;
  }
  .search-form input::placeholder {
    font-size: 20px;
  }
  .banner-area-two .banner-img img {
    max-width: 100%;
  }
  .banner-shape-wrap img:nth-child(3) {
    display: none;
  }
  .banner-shape-wrap img:nth-child(2) {
    left: 9%;
  }
  .banner-shape-wrap img:nth-child(1) {
    left: 21%;
    bottom: 37%;
  }
  .banner-content-two .title {
    font-size: 42px;
  }
  .about-img-wrap-three img:nth-child(1) {
    border-radius: 40px 0 0 0;
    max-width: 100%;
  }
  .about-img-wrap-three img:nth-child(2) {
    display: none;
  }
  .about-img-wrap-three .experience-wrap {
    width: 100%;
    padding: 30px 30px 30px 20px;
  }
  .about-shape-wrap-two img:nth-child(1) {
    display: none;
  }
  .section-title-two .title {
    font-size: 32px;
  }
  .about-author-info .signature {
    display: none;
  }
  .about-shape-wrap-two img:nth-child(3) {
    width: 300px;
  }
  .services-area-two .section-title-two {
    text-align: center;
    margin-bottom: 30px;
  }
  .services-area-two .view-all-btn {
    text-align: center !important;
  }
  .overview-img-wrap img:nth-child(2) {
    display: none;
  }
  .overview-img-wrap .icon {
    display: none;
  }
  .overview-img-wrap img:nth-child(3) {
    display: none;
  }
  .overview-img-wrap img:nth-child(1) {
    border-radius: 130px;
  }
  .skill-wrap {
    padding: 40px 20px;
  }
  .skill-wrap .section-title-two .title {
    font-size: 30px;
  }
  .section-title-two .title br {
    display: none;
  }
  .project-thumb-two img {
    width: 100%;
  }
  .cta-content {
    display: block;
    text-align: center;
  }
  .cta-info-wrap {
    width: 100%;
    margin-bottom: 25px;
    justify-content: center;
  }
  .cta-info-wrap::before {
    display: none;
  }
  .testimonial-item-wrap-two {
    padding: 0 0px;
  }
  .testimonial-item-two {
    padding: 30px 20px;
  }
  .testimonial-avatar .avatar-info .title {
    font-size: 20px;
  }
  .testimonial-content-two > p {
    font-size: 18px;
  }
  .section-title-two p {
    width: 100%;
  }
  .features-item-two {
    display: block;
    text-align: center;
  }
  .features-icon-two {
    margin: 0 auto 20px;
  }
  .services-bg-two {
    padding: 100px 0 70px;
  }
  .overview-area {
    padding: 100px 0;
  }
  .choose-bg {
    padding: 100px 0;
  }
  .project-bg-two {
    padding: 100px 0 180px;
  }
  .team-area-two {
    padding: 100px 0 70px;
  }
  .testimonial-bg-two {
    padding: 100px 0;
  }
  .pricing-area-two {
    padding: 100px 0 70px;
  }
  .blog-bg-two {
    padding: 100px 0 70px;
  }
  .request-area-two {
    padding: 100px 0;
  }
  .footer-top-two {
    padding: 80px 0 30px;
  }
  .request-content-two p {
    width: 100%;
  }
  .header-style-three .header-action .header-contact-two {
    display: none;
  }
  .header-style-three .menu-area .mobile-nav-toggler {
    margin-top: -5px;
  }
  .banner-img-three img.main-img {
    max-width: 100%;
  }
  .banner-img-three img.img-three {
    display: none;
  }
  .banner-img-three img.img-two {
    display: none;
  }
  .banner-area-three::after,
  .banner-area-three::before {
    display: none;
  }
  .overview-area-two::before {
    display: none;
  }
  .banner-area-three {
    padding: 110px 0 60px;
  }
  .banner-shape-wrap-three img:nth-child(1) {
    display: none;
  }
  .banner-shape-wrap-three img:nth-child(2) {
    display: none;
  }
  .banner-content-three .title {
    font-size: 42px;
  }
  .features-area-three {
    padding: 100px 0 70px;
  }
  .about-img-wrap-four .img-two {
    display: none;
  }
  .about-shape-wrap-three img:nth-child(1) {
    display: none;
  }
  .about-shape-wrap-three img:nth-child(3) {
    right: 22%;
    top: -7%;
  }
  .about-img-wrap-four .icon {
    width: 80px;
    height: 80px;
    left: -2%;
    top: 3%;
    font-size: 32px;
  }
  .about-area-four {
    padding: 0 0 100px;
  }
  .overview-img-two .img-two {
    display: none;
  }
  .overview-area-two {
    padding: 0 0 100px;
  }
  .project-area-three .section-title-two {
    text-align: center;
  }
  .view-all-btn.text-end {
    text-align: center !important;
  }
  .project-thumb-three img {
    width: 100%;
  }
  .project-area-three {
    padding: 0 0 70px;
  }
  .team-area-three {
    padding: 100px 0 70px;
  }
  .team-thumb-three::before {
    right: -32%;
    bottom: -12%;
    width: 80%;
    height: 160%;
    border-radius: 180px;
  }
  .testimonial-item-wrap-three {
    padding: 30px;
  }
  .testimonial-nav-three {
    display: none;
  }
  .cta-area-two {
    padding: 100px 0 0;
  }
  .blog-area-three {
    padding: 100px 0 70px;
  }
  .footer-top-three {
    padding: 90px 0 30px;
  }
  .testimonial-img-four {
    padding-left: 0;
    text-align: center;
  }
  .testimonial-img-four::before {
    width: 320px;
    height: 320px;
    left: 50%;
    transform: translateX(-50%);
  }
  .testimonial-img-four .icon {
    display: none;
  }
  .header-style-four .heder-top-wrap {
    display: none;
  }
  .header-style-four .header-contact-two {
    display: none;
  }
  .header-style-four .menu-area .mobile-nav-toggler {
    margin-top: -6px;
  }
  .about-content-five .about-content-bottom {
    flex-wrap: wrap;
  }
  .banner-shape-wrap-four img:nth-child(3) {
    width: 200px;
  }
  .banner-shape-wrap-four img:nth-child(2) {
    display: none;
  }
  .banner-bg-four {
    padding: 50px 0 140px;
  }
  .banner-content-four .title {
    font-size: 42px;
  }
  .banner-shape-wrap-four img:nth-child(1) {
    display: none;
  }
  .features-item-four {
    display: block;
    text-align: center;
  }
  .features-icon-four {
    width: 80px;
    height: 80px;
    margin: 0 auto 20px;
  }
  .features-icon-four::before {
    right: auto;
    left: 50%;
    bottom: 0;
    top: auto;
    transform: translateX(-50%);
    width: 16px;
    height: 3px;
  }
  .about-img-wrap-five img:nth-child(2) {
    display: none;
  }
  .about-img-wrap-five::before {
    display: none;
  }
  .about-img-wrap-five .experience-wrap {
    max-width: 165px;
    padding: 20px 20px;
  }
  .about-img-wrap-five .experience-wrap .title {
    font-size: 42px;
  }
  .about-img-wrap-five .experience-wrap .title span {
    font-size: 20px;
  }
  .about-img-wrap-five {
    padding-bottom: 0px;
  }
  .about-content-five .about-list {
    width: 100%;
    margin-bottom: 30px;
  }
  .services-area-three .section-title-two {
    text-align: center;
    margin-bottom: 30px;
  }
  .cta-info-wrap.cta-info-wrap-two .icon {
    width: 60px;
    height: 60px;
    font-size: 30px;
  }
  .testimonial-item-wrap-four {
    padding-right: 0;
  }
  .testimonial-nav-four {
    display: none;
  }
  .testimonial-content-four > p {
    font-size: 20px;
    margin-bottom: 22px;
  }
  .testimonial-content-four .rating {
    margin-bottom: 25px;
  }
  .about-area-five {
    padding: 100px 0;
  }
  .brand-item-wrap-two {
    padding: 50px 0;
  }
  .services-area-three {
    padding: 100px 0 70px;
  }
  .choose-area-two {
    padding: 100px 0 180px;
  }
  .estimate-area {
    padding: 100px 0 0;
  }
  .team-area-four {
    padding: 100px 0 70px;
  }
  .testimonial-bg-four {
    padding: 100px 0;
  }
  .pricing-area-three {
    padding: 100px 0 70px;
  }
  .blog-area-four {
    padding: 100px 0 70px;
  }
  .testimonial-img-four .shape {
    left: 50%;
    transform: translatex(-50%);
  }
  .header-style-five .header-action {
    display: none;
  }
  .banner-img-five .main-img {
    max-width: 100%;
    width: 100%;
  }
  .banner-img-five .shape-two {
    width: 90px;
  }
  .banner-img-five .shape-three {
    width: 50px;
    right: 16%;
    top: 9%;
  }
  .banner-img-five .shape-one {
    width: 150px;
    right: 0;
  }
  .banner-content-five .title {
    font-size: 42px;
  }
  .banner-area-five::after {
    display: none;
  }
  .banner-content-five {
    margin-top: 30px;
  }
  .testimonial-content-five {
    padding-right: 0;
  }
  .testimonial-nav-five {
    display: none;
  }
  .project-area-four .section-title {
    text-align: center;
    margin-bottom: 30px;
  }
  .project-area-four .section-title .sub-title::before {
    left: 50%;
    transform: translateX(-50%);
  }
  .services-area-four {
    padding: 100px 0 70px;
  }
  .about-area-six {
    padding: 0 0 100px;
  }
  .counter-area-three {
    padding: 0 0 70px;
  }
  .team-area-five {
    padding: 0 0 70px;
  }
  .project-area-four {
    padding: 100px 0 170px;
  }
  .testimonial-area-five {
    padding: 100px 0;
  }
  .blog-area-five {
    padding: 0 0 70px;
  }
  .breadcrumb-shape-wrap img:nth-child(2) {
    display: none;
  }
  .about-img-seven-wrap .experience-wrap {
    display: none;
  }
  .about-img-seven-wrap img:nth-child(2) {
    display: none;
  }
  .about-img-seven-wrap img:nth-child(1) {
    width: auto;
  }
  .about-img-seven-wrap {
    padding-bottom: 0;
  }
  .about-area-seven {
    padding: 100px 0;
  }
  .features-bg {
    padding: 100px 0 60px;
  }
  .about-img-seven-wrap {
    text-align: center;
  }
  .breadcrumb-content .title {
    font-size: 38px;
  }
  .breadcrumb-shape-wrap img:nth-child(1) {
    width: 300px;
  }
  .about-content-eight .about-content-inner .list-wrap {
    width: 100%;
  }
  .about-content-eight .about-content-inner .list-wrap li .icon {
    width: 70px;
    height: 70px;
    font-size: 35px;
  }
  .about-content-eight .right-slide-img {
    margin: 30px 0 0;
  }
  .about-area-eight {
    padding: 100px 0;
  }
  .choose-area-three {
    padding: 100px 0;
  }
  .accordion-wrap-two .accordion-button {
    padding: 16px 50px 16px 22px;
  }
  .accordion-wrap-two .accordion-body {
    padding: 20px 30px 30px 22px;
  }
  .testimonial-area-six {
    padding: 100px 0 0;
  }
  .about-area-nine {
    padding: 100px 0;
  }
  .counter-area-four {
    padding: 200px 0 100px;
  }
  .counter-item-wrap-four .list-wrap li {
    width: 100%;
  }
  .about-area-ten {
    padding: 100px 0;
  }
  .about-content-ten .about-success-wrap .list-wrap {
    flex-wrap: wrap;
  }
  .features-area-seven {
    padding: 210px 0 100px;
  }
  .about-img-wrap-ten {
    padding-left: 0;
  }
  .about-area-eleven {
    padding: 100px 0 0;
  }
  .about-area-six {
    padding: 100px 0 100px;
  }
  .team-area-six {
    padding: 200px 0 70px;
  }
  .inner-services-bg {
    padding: 100px 0 70px;
  }
  .services-thumb img {
    width: 100%;
  }
  .services-area-six {
    padding: 100px 0 70px;
  }
  .services-area-seven {
    padding: 100px 0 70px;
  }
  .services-details-thumb img {
    min-height: 250px;
    object-fit: cover;
  }
  .services-details-content .title {
    font-size: 26px;
  }
  .sd-inner-wrap .row .col-56 {
    width: 100%;
  }
  .sd-inner-wrap .row .col-44 {
    width: 100%;
  }
  .sd-inner-wrap .thumb {
    margin-top: 30px;
  }
  .sd-inner-wrap .content .list-wrap li {
    width: 100%;
  }
  .accordion-wrap-three .accordion-button {
    padding: 16px 45px 16px 20px;
    font-size: 18px;
  }
  .accordion-wrap-three .accordion-body {
    padding: 20px 35px 30px 20px;
  }
  .services-details-area .row .col-29 {
    width: 100%;
  }
  .services-widget {
    padding: 30px 25px 35px;
  }
  .services-sidebar {
    margin-top: 100px;
  }
  .services-details-area {
    padding: 100px 0;
  }
  .sd-inner-wrap-two .row .col-58 {
    width: 100%;
  }
  .sd-inner-wrap-two .thumb img {
    width: 100%;
  }
  .sd-inner-wrap-two .row .col-42 {
    width: 100%;
  }
  .services-details-list {
    margin-top: 30px;
  }
  .industrial-working-wrap img {
    width: 100%;
  }
  .sd-inner-wrap-three .col-57 {
    width: 100%;
  }
  .sd-inner-wrap-three .col-43 {
    width: 100%;
  }
  .services-details-list-two {
    margin-bottom: 30px;
  }
  .services-details-list-three .list-wrap {
    flex-wrap: wrap;
  }
  .services-details-list-three .list-wrap li {
    display: block;
  }
  .services-details-list-three .list-wrap li .icon {
    margin-right: 0;
    margin-bottom: 15px;
  }
  .services-details-thumb-two img {
    width: 100%;
    min-height: 250px;
    object-fit: cover;
  }
  .sd-inner-wrap-five .row .col-50 {
    width: 100%;
  }
  .sd-inner-wrap-five .left-side-content {
    margin-bottom: 30px;
  }
  .project-details-area {
    padding: 100px 0;
  }
  .project-details-thumb img {
    min-height: 250px;
  }
  .project-details-info {
    padding: 25px 25px 28px;
  }
  .project-details-content .title {
    font-size: 26px;
  }
  .pd-optimized-wrap {
    margin-top: 40px;
    margin-bottom: 50px;
  }
  .pd-inner-wrap .content .list-wrap li {
    width: 100%;
  }
  .pd-inner-wrap .thumb img {
    min-height: 250px;
    object-fit: cover;
    width: 100%;
  }
  .team-details-area {
    padding: 100px 0;
  }
  .team-details-content > .title {
    font-size: 26px;
  }
  .inner-blog-wrap .row .col-29 {
    width: 100%;
  }
  .blog-widget {
    padding: 25px 25px 30px;
  }
  .blog-area {
    padding: 100px 0;
  }
  .blog-sidebar {
    margin-top: 100px;
  }
  .blog-details-thumb img {
    width: 100%;
    min-height: 250px;
    object-fit: cover;
  }
  .blog-details-content > .title {
    font-size: 26px;
  }
  .blog-details-content blockquote {
    margin: 40px 0 50px;
    padding: 40px 30px 40px 30px;
  }
  .blog-details-content blockquote::after {
    font-size: 40px;
    right: 16px;
    top: 16px;
  }
  .bd-inner-wrap .row .col-46 {
    width: 100%;
  }
  .bd-inner-wrap .thumb {
    margin-bottom: 30px;
  }
  .bd-inner-wrap .row .col-54 {
    width: 100%;
  }
  .bd-content-bottom .blog-post-share {
    justify-content: flex-start;
    margin-top: 15px;
  }
  .blog-avatar-wrap {
    padding: 30px 25px;
    display: block;
  }
  .blog-avatar-img {
    margin-right: 0;
    margin-bottom: 20px;
  }
  .comments-box {
    display: block;
  }
  .comments-avatar {
    margin-right: 0;
    margin-bottom: 20px;
  }
  .latest-comments .children {
    margin: 0;
  }
  .comment-form .checkbox-grp {
    align-items: flex-start;
  }
  .blog-details-wrap .row .col-29 {
    width: 100%;
  }
  .blog-details-area {
    padding: 100px 0;
  }
  .inner-contact-area {
    padding: 100px 0;
  }
  .inner-contact-info .title {
    font-size: 28px;
  }
  .contact-map {
    height: 350px;
  }
  .error-content .error-404 {
    font-size: 150px;
  }
  .error-content .title {
    font-size: 30px;
  }
  .error-content p br {
    display: none;
  }
  .error-area {
    padding: 100px 0;
  }
}

/* Small devices (landscape phones, 576px and up) */
@media only screen and (min-width: 576px) and (max-width: 767px) {
  .container,
  .custom-container {
    max-width: 540px;
  }
  .slider-content .title {
    font-size: 45px;
  }
  .about-img-wrap img.main-img {
    width: 314px;
    height: 314px;
  }
  .about-list .list-wrap li {
    width: 50%;
  }
  .success-wrap .list-wrap {
    gap: 0;
  }
  .success-wrap .list-wrap li {
    width: 50%;
  }
  .services-content .content-top .title {
    font-size: 24px;
  }
  .services-item {
    padding: 25px 30px 35px;
  }
  .swiper-container.project-active {
    margin-right: -200px;
  }
  .blog-post-content {
    padding: 25px 30px 30px;
  }
  .blog-post-content .title {
    font-size: 22px;
  }
  .banner-content-two .title {
    font-size: 45px;
  }
  .banner-area-two .banner-img img {
    max-width: 320px;
  }
  .banner-shape-wrap img:nth-child(1) {
    left: 21%;
    bottom: 42%;
  }
  .content-bottom .list-wrap li {
    min-width: 240px;
  }
  .skill-wrap {
    padding: 40px 40px;
  }
  .project-content-two .title {
    font-size: 26px;
  }
  .testimonial-item-two {
    padding: 30px 30px;
  }
  .blog-post-content-two {
    padding: 35px 25px;
  }
  .blog-post-content-two .title {
    font-size: 24px;
  }
  .banner-content-three .title {
    font-size: 45px;
  }
  .testimonial-item-wrap-three {
    padding: 40px;
  }
  .banner-content-four .title {
    font-size: 45px;
  }
  .about-img-wrap-five {
    text-align: center;
  }
  .about-shape-five img {
    right: 8%;
  }
  .banner-img-five .shape-one {
    width: 240px;
  }
  .banner-img-five .shape-three {
    width: 60px;
    right: 23%;
    top: 20%;
  }
  .banner-content-five .title {
    font-size: 45px;
  }
  .counter-icon {
    font-size: 48px;
  }
  .counter-item-three {
    padding: 28px 20px;
  }
  .about-content-eight .about-content-inner .list-wrap {
    width: 62%;
  }
  .about-content-eight .right-slide-img {
    margin: 0 0 0 auto;
    width: 36%;
  }
  .counter-item-wrap-four .list-wrap li {
    width: 50%;
  }
  .about-area-ten .about-shape-five img {
    left: auto;
    right: 9%;
  }
  .services-details-content .title-two {
    font-size: 26px;
  }
  .services-details-content .title {
    font-size: 28px;
  }
  .services-details-list .list-wrap li .icon {
    width: 70px;
    height: 70px;
    margin-right: 20px;
  }
  .services-details-list-two .list-wrap li {
    padding: 25px 30px;
    display: flex;
  }
  .services-details-list-two .list-wrap li .icon {
    margin-right: 10px;
    margin-bottom: 0;
  }
  .sd-inner-wrap-four .thumb img {
    max-height: 360px;
  }
  .project-details-content .title {
    font-size: 28px;
  }
  .team-details-content > .title {
    font-size: 28px;
  }
  .blog-details-content > .title {
    font-size: 28px;
  }
  .comment-form .checkbox-grp input {
    margin-top: 5px;
  }
  .comment-respond {
    padding: 35px 30px 50px;
  }
  .blog-widget {
    padding: 25px 30px 30px;
  }
  .blog-avatar-wrap {
    padding: 30px 30px;
  }
  .inner-contact-info .title {
    font-size: 30px;
  }
  .error-content .error-404 {
    font-size: 200px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/responsive.css"],"names":[],"mappings":"AAAA,wDAAwD;AACxD;EACE;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;EACA;IACE,SAAS;EACX;AACF;;AAEA,wDAAwD;AACxD;EACE;IACE,iBAAiB;EACnB;EACA;IACE,QAAQ;EACV;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,QAAQ;IACR,WAAW;EACb;EACA;IACE,QAAQ;EACV;EACA;IACE,SAAS;EACX;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,QAAQ;EACV;EACA;IACE,eAAe;EACjB;EACA;IACE,UAAU;EACZ;EACA;IACE,qBAAqB;EACvB;EACA;IACE,eAAe;EACjB;EACA;IACE,SAAS;EACX;EACA;IACE,UAAU;EACZ;EACA;IACE,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,OAAO;EACT;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA,oEAAoE;AACpE;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA,wDAAwD;AACxD;EACE;;IAEE,gBAAgB;EAClB;EACA;;;;wEAIsE;EACtE;IACE,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,mBAAmB;IACnB,WAAW;EACb;EACA;IACE,QAAQ;IACR,UAAU;EACZ;EACA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,SAAS;EACX;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,yBAAyB;IACzB,OAAO;IACP,gBAAgB;EAClB;EACA;IACE,UAAU;EACZ;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,OAAO;EACT;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;IACT,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;IACV,YAAY;EACd;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,yBAAyB;IACzB,gBAAgB;EAClB;EACA;IACE,iCAAiC;IACjC,WAAW;IACX,YAAY;IACZ,YAAY;EACd;EACA;IACE,WAAW;IACX,+BAA+B;IAC/B,6BAA6B;EAC/B;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,QAAQ;EACV;EACA;IACE,SAAS;IACT,QAAQ;EACV;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,4BAA4B;IAC5B,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,cAAc;EAChB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;IACV,YAAY;EACd;EACA;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,SAAS;EACX;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,SAAS;EACX;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,UAAU;IACV,QAAQ;EACV;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;;;;IAIE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,YAAY;IACZ,SAAS;IACT,QAAQ;IACR,eAAe;EACjB;EACA;IACE,OAAO;IACP,YAAY;EACd;EACA;IACE,QAAQ;IACR,UAAU;EACZ;EACA;IACE,UAAU;IACV,QAAQ;EACV;EACA;IACE,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,cAAc;EAChB;EACA;IACE,SAAS;IACT,OAAO;EACT;EACA;IACE,SAAS;IACT,QAAQ;EACV;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;IACZ,aAAa;EACf;EACA;IACE,kBAAkB;EACpB;EACA;IACE,UAAU;IACV,WAAW;IACX,UAAU;EACZ;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,mBAAmB;IACnB,WAAW;EACb;EACA;IACE,oBAAoB;EACtB;EACA;IACE,SAAS;EACX;EACA;IACE,UAAU;EACZ;EACA;IACE,SAAS;IACT,WAAW;EACb;EACA;IACE,uBAAuB;EACzB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,cAAc;IACd,WAAW;EACb;EACA;IACE,mBAAmB;IACnB,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;IACT,OAAO;EACT;EACA;IACE,SAAS;IACT,QAAQ;EACV;EACA;IACE,kBAAkB;EACpB;EACA;IACE,UAAU;EACZ;EACA;IACE,mBAAmB;EACrB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;EACA;IACE,UAAU;EACZ;EACA;IACE,cAAc;EAChB;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;IACX,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,WAAW;EACb;EACA;IACE,mBAAmB;EACrB;EACA;IACE,YAAY;EACd;EACA;IACE,SAAS;EACX;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,SAAS;EACX;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,cAAc;EAChB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,OAAO;EACT;EACA;IACE,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,cAAc;EAChB;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,uBAAuB;EACzB;EACA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,uBAAuB;EACzB;EACA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,eAAe;EACjB;EACA;IACE,mBAAmB;IACnB,6BAA6B;EAC/B;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA,2CAA2C;AAC3C;EACE;;IAEE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,kBAAkB;EACpB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,cAAc;EAChB;EACA;IACE,YAAY;EACd;EACA;IACE,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,SAAS;IACT,2BAA2B;EAC7B;EACA;IACE,iBAAiB;IACjB,qBAAqB;IACrB,gCAAgC;EAClC;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;IACd,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,aAAa;EACf;EACA;IACE,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,SAAS;IACT,2BAA2B;EAC7B;EACA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,cAAc;EAChB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,aAAa;EACf;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,SAAS;IACT,WAAW;EACb;EACA;IACE,WAAW;IACX,SAAS;EACX;EACA;IACE,UAAU;IACV,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,UAAU;EACZ;EACA;IACE,QAAQ;EACV;EACA;IACE,oBAAoB;IACpB,mBAAmB;EACrB;EACA;IACE,SAAS;IACT,YAAY;IACZ,QAAQ;EACV;EACA;IACE,UAAU;IACV,OAAO;IACP,UAAU;EACZ;EACA;IACE,eAAe;EACjB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,UAAU;EACZ;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,UAAU;IACV,QAAQ;IACR,YAAY;EACd;EACA;IACE,QAAQ;EACV;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;IACZ,QAAQ;IACR,SAAS;EACX;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,aAAa;IACb,oBAAoB;EACtB;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,OAAO;IACP,wBAAwB;EAC1B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,UAAU;IACV,YAAY;EACd;EACA;IACE,WAAW;IACX,SAAS;IACT,YAAY;IACZ,QAAQ;EACV;EACA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,UAAU;IACV,YAAY;IACZ,QAAQ;EACV;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,WAAW;IACX,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,WAAW;EACb;EACA;IACE,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,SAAS;EACX;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,iBAAiB;EACnB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,uBAAuB;EACzB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;EACA;IACE,iBAAiB;EACnB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;AACF;;AAEA,2CAA2C;AAC3C;EACE;IACE,eAAe;EACjB;EACA;IACE,MAAM;EACR;EACA;IACE,uBAAuB;EACzB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,qBAAqB;EACvB;EACA;IACE,YAAY;IACZ,aAAa;EACf;EACA;IACE,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,mBAAmB;IACnB,iCAAiC;IACjC,WAAW;EACb;EACA;IACE,qBAAqB;EACvB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;IACf,SAAS;EACX;EACA;IACE,qBAAqB;EACvB;EACA;IACE,WAAW;EACb;EACA;IACE,uBAAuB;EACzB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,eAAe;EACjB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;IACE,oBAAoB;IACpB,4BAA4B;EAC9B;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,OAAO;EACT;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,gBAAgB;IAChB,2BAA2B;EAC7B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;IACV,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,uBAAuB;IACvB,eAAe;EACjB;EACA;IACE,WAAW;IACX,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,QAAQ;EACV;EACA;IACE,SAAS;IACT,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,yBAAyB;IACzB,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,4BAA4B;EAC9B;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,cAAc;IACd,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;IACE,cAAc;IACd,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;;IAEE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,qBAAqB;EACvB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;IACV,QAAQ;EACV;EACA;IACE,WAAW;IACX,YAAY;IACZ,SAAS;IACT,OAAO;IACP,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,WAAW;EACb;EACA;IACE,iBAAiB;EACnB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,WAAW;IACX,YAAY;IACZ,UAAU;IACV,YAAY;IACZ,oBAAoB;EACtB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;EACpB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,YAAY;IACZ,aAAa;IACb,SAAS;IACT,2BAA2B;EAC7B;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,qBAAqB;EACvB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;IACd,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,SAAS;IACT,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,WAAW;IACX,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,SAAS;IACT,2BAA2B;EAC7B;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;IACf,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,UAAU;IACV,OAAO;EACT;EACA;IACE,YAAY;IACZ,QAAQ;EACV;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,SAAS;IACT,2BAA2B;EAC7B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,WAAW;EACb;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,4BAA4B;IAC5B,eAAe;EACjB;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,WAAW;EACb;EACA;IACE,uBAAuB;EACzB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,WAAW;EACb;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,WAAW;EACb;EACA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,mBAAmB;IACnB,4BAA4B;EAC9B;EACA;IACE,eAAe;IACf,WAAW;IACX,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,mBAAmB;EACrB;EACA;IACE,WAAW;EACb;EACA;IACE,2BAA2B;IAC3B,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,cAAc;EAChB;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,SAAS;EACX;EACA;IACE,uBAAuB;EACzB;EACA;IACE,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA,mDAAmD;AACnD;EACE;;IAEE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;IACZ,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,MAAM;EACR;EACA;IACE,UAAU;EACZ;EACA;IACE,eAAe;EACjB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,SAAS;IACT,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,SAAS;EACX;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;IACX,UAAU;IACV,QAAQ;EACV;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,UAAU;EACZ;EACA;IACE,kBAAkB;IAClB,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;AACF","sourcesContent":["/* Extra large devices (large desktops, 1800px and up) */\n@media (max-width: 1800px) {\n  .faq-shape-wrap img:nth-child(2) {\n    left: 9%;\n  }\n  .banner-shape {\n    left: 8%;\n  }\n  .about-shape-wrap-two img:nth-child(1) {\n    left: 11%;\n  }\n}\n\n/* Extra large devices (large desktops, 1800px and up) */\n@media (max-width: 1500px) {\n  .container {\n    max-width: 1250px;\n  }\n  .slider-shape {\n    left: 4%;\n  }\n  .slider-bg {\n    min-height: 670px;\n  }\n  .slider-content .title {\n    font-size: 55px;\n  }\n  .faq-shape-wrap img:nth-child(2) {\n    left: 7%;\n    bottom: 47%;\n  }\n  .about-shape-wrap-two img:nth-child(1) {\n    left: 3%;\n  }\n  .about-shape-wrap-two img:nth-child(2) {\n    left: 36%;\n  }\n  .about-shape-wrap-two img:nth-child(3) {\n    width: 380px;\n  }\n  .choose-shape img {\n    width: 300px;\n  }\n  .pricing-shape img {\n    width: 300px;\n  }\n  .request-shape-wrap img:nth-child(1) {\n    left: 3%;\n  }\n  .banner-content-two .title {\n    font-size: 55px;\n  }\n  .banner-shape-wrap img:nth-child(3) {\n    right: 19%;\n  }\n  .banner-area-three {\n    padding: 120px 0 60px;\n  }\n  .banner-content-three .title {\n    font-size: 56px;\n  }\n  .overview-img-two .img-two {\n    left: -8%;\n  }\n  .about-img-wrap-five img:nth-child(2) {\n    left: -11%;\n  }\n  .about-shape-five img {\n    left: 34%;\n  }\n  .banner-content-four .title {\n    font-size: 55px;\n  }\n  .banner-area-five {\n    padding: 115px 0 80px;\n  }\n  .breadcrumb-bg {\n    padding: 110px 0 120px;\n  }\n  .about-img-wrap-ten img:nth-child(2) {\n    left: 0;\n  }\n  .error-area {\n    padding: 120px 0;\n  }\n  .error-content .error-404 {\n    font-size: 350px;\n  }\n}\n\n/* Narrow desktop only: below 992px mobile.css owns the logo size. */\n@media (min-width: 992px) and (max-width: 1199.98px) {\n  .menu-area .logo img {\n    max-height: 38px !important;\n  }\n}\n\n/* Extra large devices (large desktops, 1200px and up) */\n@media (max-width: 1199.98px) {\n  .container,\n  .custom-container {\n    max-width: 960px;\n  }\n  /* The row no longer wraps, so on the narrowest desktop the nav and the\n     account block have to share a tighter budget rather than spill over. The\n     container is 960px here and seven nav items plus a signed-in account block\n     do not both fit at full size, so the name gives way to the avatar (which\n     still links to the profile) and the logo comes down a few pixels. */\n  .navbar-wrap ul li a {\n    padding: 20px 10px;\n    font-size: 15px;\n  }\n  .header-action > ul {\n    margin-left: 15px;\n  }\n  .header-action > ul li {\n    margin-left: 15px;\n  }\n  .header-profile-name {\n    display: none;\n  }\n  .slider-content .title {\n    font-size: 50px;\n  }\n  .slider-content p {\n    margin-bottom: 30px;\n    width: 100%;\n  }\n  .slider-shape {\n    left: 4%;\n    bottom: 7%;\n  }\n  .slider-bg {\n    min-height: 590px;\n    padding: 170px 0 100px;\n  }\n  .about-content {\n    width: 100%;\n  }\n  .section-title .title {\n    font-size: 36px;\n  }\n  .about-img-wrap img:nth-child(3) {\n    right: 8%;\n  }\n  .features-item {\n    padding: 35px 25px;\n  }\n  .about-img-two {\n    padding-left: 75px;\n  }\n  .about-img-two img:nth-child(2) {\n    border: 5px solid #ffffff;\n    left: 0;\n    max-width: 215px;\n  }\n  .about-shape-wrap img:nth-child(1) {\n    right: 45%;\n  }\n  .success-wrap .list-wrap li .count {\n    font-size: 32px;\n  }\n  .about-list .list-wrap li {\n    font-size: 16px;\n  }\n  .services-content .content-top .title {\n    font-size: 22px;\n  }\n  .services-item {\n    padding: 25px 25px 35px;\n  }\n  .services-content .list-wrap li {\n    align-items: baseline;\n  }\n  .counter-item .count {\n    font-size: 50px;\n  }\n  .faq-content > p {\n    width: 100%;\n  }\n  .faq-content .accordion-wrap {\n    width: 100%;\n  }\n  .faq-img-wrap {\n    margin-right: 0;\n  }\n  .faq-shape-wrap img:nth-child(2) {\n    left: 0;\n  }\n  .request-content .title {\n    font-size: 30px;\n  }\n  .request-content .title br {\n    display: none;\n  }\n  .testimonial-content {\n    width: 100%;\n  }\n  .pricing-box {\n    padding: 40px 25px;\n  }\n  .contact-form {\n    margin: 0;\n  }\n  .blog-post-content .title {\n    font-size: 20px;\n  }\n  .blog-post-content {\n    padding: 25px 22px 30px;\n  }\n  .blog-post-thumb img {\n    min-height: 225px;\n    object-fit: cover;\n  }\n  .footer-newsletter p {\n    width: 100%;\n  }\n  .footer-widget .fw-title {\n    font-size: 22px;\n  }\n  .footer-info .list-wrap li .content p br {\n    display: none;\n  }\n  .footer-bottom {\n    padding: 40px 0;\n  }\n  .header-style-two .header-action > ul li.header-contact-two {\n    display: none;\n  }\n  .banner-content-two .title {\n    font-size: 50px;\n  }\n  .banner-content-two {\n    width: 100%;\n  }\n  .banner-shape-wrap img:nth-child(1) {\n    left: 51%;\n    bottom: 51%;\n  }\n  .banner-shape-wrap img:nth-child(2) {\n    right: 39%;\n  }\n  .banner-shape-wrap img:nth-child(3) {\n    right: 13%;\n    width: 400px;\n  }\n  .banner-area-two .banner-img.text-center {\n    text-align: right !important;\n  }\n  .banner-area-two .banner-img img {\n    max-width: 380px;\n  }\n  .banner-bg-two {\n    min-height: 700px;\n  }\n  .features-content-two p {\n    width: 100%;\n  }\n  .section-title-two .title {\n    font-size: 36px;\n  }\n  .about-img-wrap-three img:nth-child(1) {\n    border-radius: 80px 0 0 0;\n    max-width: 380px;\n  }\n  .about-img-wrap-three img:nth-child(2) {\n    border: 5px solid var(--tg-white);\n    bottom: 20%;\n    width: 200px;\n    right: -10px;\n  }\n  .about-img-wrap-three .experience-wrap {\n    width: auto;\n    border-radius: 0px 0px 0px 35px;\n    padding: 30px 185px 30px 20px;\n  }\n  .about-img-wrap-three .experience-wrap .title {\n    font-size: 40px;\n  }\n  .about-img-wrap-three .experience-wrap .title span {\n    font-size: 18px;\n  }\n  .about-shape-wrap-two img:nth-child(1) {\n    left: 1%;\n  }\n  .about-shape-wrap-two img:nth-child(2) {\n    left: 33%;\n    top: 10%;\n  }\n  .about-content-three p {\n    width: 100%;\n  }\n  .about-shape-wrap-two img:nth-child(3) {\n    width: 340px;\n  }\n  .overview-content {\n    width: 100%;\n  }\n  .content-bottom .list-wrap li {\n    padding: 28px 15px 28px 20px;\n    min-width: 200px;\n  }\n  .content-bottom .list-wrap li .icon {\n    font-size: 36px;\n    margin-right: 30px;\n  }\n  .content-bottom .list-wrap li .icon::after {\n    right: -15px;\n  }\n  .content-bottom .list-wrap li .content .count {\n    font-size: 30px;\n  }\n  .skill-wrap {\n    padding: 60px 35px;\n    margin-left: 0;\n  }\n  .choose-content {\n    width: 100%;\n  }\n  .project-content-top p {\n    width: 100%;\n  }\n  .project-content-two .title {\n    font-size: 24px;\n  }\n  .project-content-two {\n    padding: 20px;\n  }\n  .project-content-two .link-btn {\n    right: 20px;\n    bottom: 20px;\n  }\n  .cta-inner-wrap {\n    padding: 70px 30px;\n  }\n  .cta-info-wrap .icon {\n    font-size: 35px;\n  }\n  .cta-info-wrap .content a {\n    font-size: 26px;\n  }\n  .cta-info-wrap::before {\n    right: 38px;\n    height: 66px;\n  }\n  .section-top-content p {\n    width: 100%;\n  }\n  .testimonial-item-two {\n    padding: 30px 30px;\n  }\n  .testimonial-nav-two .slick-arrow {\n    left: -30px;\n  }\n  .testimonial-nav-two .slick-arrow.slick-next {\n    left: auto;\n    right: -30px;\n  }\n  .pricing-head-two {\n    padding: 40px 25px 40px;\n  }\n  .pricing-price-two .price {\n    font-size: 35px;\n  }\n  .pricing-bottom {\n    padding: 30px 25px 40px;\n  }\n  .pricing-box-two .popular {\n    top: 45px;\n  }\n  .blog-post-content-two {\n    padding: 35px 20px;\n  }\n  .blog-post-content-two .title {\n    font-size: 22px;\n  }\n  .footer-top-two .footer-info .list-wrap li .content p br {\n    display: block;\n  }\n  .footer-top-two .footer-content > p {\n    width: 100%;\n  }\n  .banner-img-three {\n    padding-right: 0;\n  }\n  .banner-img-three img.main-img {\n    max-width: 410px;\n  }\n  .about-img-wrap-four {\n    margin-right: 0;\n  }\n  .mask-img-wrap {\n    height: auto;\n    width: 100%;\n  }\n  .mask-img-wrap img {\n    max-width: unset;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n  .overview-img-two .img-two {\n    left: -4%;\n  }\n  .mask-img-two {\n    height: auto;\n    width: 100%;\n  }\n  .banner-img-three img.img-three {\n    right: -1%;\n    top: 17%;\n  }\n  .banner-content-three .banner-form {\n    width: 100%;\n  }\n  .header-contact-two {\n    margin-right: 0;\n  }\n  .header-style-three .header-action > ul {\n    margin-left: 30px;\n  }\n  .features-item-wrap-two\n    .row\n    [class*=\"col-\"]:nth-child(even)\n    .features-item-three {\n    margin-top: 0;\n  }\n  .about-list-three .content p {\n    width: 100%;\n  }\n  .about-img-wrap-four .icon {\n    width: 90px;\n    height: 90px;\n    left: -1%;\n    top: 11%;\n    font-size: 40px;\n  }\n  .about-shape-wrap-three img:nth-child(1) {\n    top: 8%;\n    width: 475px;\n  }\n  .about-shape-wrap-three img:nth-child(2) {\n    left: 2%;\n    bottom: 6%;\n  }\n  .about-shape-wrap-three img:nth-child(3) {\n    right: 31%;\n    top: -3%;\n  }\n  .mask-img-two img {\n    max-width: unset;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n  .overview-content-two {\n    margin-left: 0;\n  }\n  .overview-shape-wrap img:nth-child(1) {\n    right: 0%;\n    top: 8%;\n  }\n  .overview-shape-wrap img:nth-child(2) {\n    right: 0%;\n    top: 23%;\n  }\n  .counter-item-two .count {\n    font-size: 45px;\n  }\n  .team-thumb-three::before {\n    right: -63px;\n    bottom: -32px;\n  }\n  .testimonial-item-wrap-three {\n    padding: 32px 40px;\n  }\n  .testimonial-nav-three {\n    left: auto;\n    bottom: 14%;\n    right: 25%;\n  }\n  .cta-inner-wrap-two {\n    padding: 70px 30px;\n  }\n  .section-title-two p {\n    width: 100%;\n  }\n  .banner-content-four {\n    margin-top: 20px;\n  }\n  .banner-content-four .title {\n    font-size: 50px;\n  }\n  .banner-content-four p {\n    margin-bottom: 20px;\n    width: 100%;\n  }\n  .banner-bg-four {\n    padding: 60px 0 30px;\n  }\n  .banner-shape-wrap-four img:nth-child(3) {\n    right: 4%;\n  }\n  .banner-shape-wrap-four img:nth-child(2) {\n    right: 35%;\n  }\n  .banner-shape-wrap-four img:nth-child(1) {\n    left: 26%;\n    bottom: 27%;\n  }\n  .features-item-wrap-four {\n    padding: 50px 25px 20px;\n  }\n  .features-icon-four {\n    width: 70px;\n    height: 70px;\n  }\n  .about-content-five {\n    margin-left: 0;\n    width: 100%;\n  }\n  .about-content-five > p {\n    margin-bottom: 40px;\n    width: 100%;\n  }\n  .about-success-wrap .list-wrap li .content .count {\n    font-size: 40px;\n  }\n  .about-success-wrap .list-wrap li .icon {\n    font-size: 50px;\n    margin-right: 15px;\n  }\n  .about-img-wrap-five .experience-wrap .title {\n    font-size: 50px;\n  }\n  .about-img-wrap-five img:nth-child(2) {\n    left: -23px;\n  }\n  .about-shape-five img {\n    left: 39%;\n  }\n  .choose-content-two {\n    width: 100%;\n  }\n  .choose-content-two > p {\n    width: 100%;\n  }\n  .choose-img-two img:nth-child(2) {\n    right: 2%;\n    top: 0%;\n  }\n  .choose-img-two img:nth-child(3) {\n    right: 0%;\n    top: 28%;\n  }\n  .cta-inner-wrap-three {\n    padding: 50px 25px;\n  }\n  .estimate-content {\n    padding: 0;\n  }\n  .testimonial-item-wrap-four {\n    padding-right: 90px;\n  }\n  .pricing-box-three {\n    padding: 40px 25px 40px;\n  }\n  .blog-post-content-four {\n    padding: 40px 25px 30px;\n  }\n  .blog-post-content-four .title {\n    font-size: 20px;\n  }\n  .blog-post-content-four .tag {\n    left: 20px;\n  }\n  .banner-img-five {\n    margin-left: 0;\n  }\n  .banner-img-five .main-img {\n    width: 650px;\n  }\n  .banner-img-five .shape-one {\n    right: -14%;\n    bottom: 14%;\n  }\n  .banner-content-five .title {\n    font-size: 45px;\n  }\n  .banner-area-five::after {\n    right: -47%;\n    top: -14%;\n  }\n  .section-title-three p {\n    width: 100%;\n  }\n  .services-item-four {\n    padding: 40px 25px 45px;\n  }\n  .about-img-six img:nth-child(1) {\n    max-width: 100%;\n  }\n  .about-img-six {\n    margin-left: 0;\n  }\n  .about-content-six {\n    width: 100%;\n  }\n  .testimonial-content-five {\n    padding-right: 70px;\n  }\n  .testimonial-nav-five {\n    right: -90px;\n  }\n  .testimonial-img-five .shape-one {\n    left: -2%;\n  }\n  .testimonial-img-five .shape-two {\n    left: 7%;\n  }\n  .testimonial-img-five .shape-three {\n    left: 2%;\n  }\n  .about-content-seven {\n    width: 100%;\n  }\n  .success-wrap-two .list-wrap li {\n    padding: 30px 20px;\n    min-width: 206px;\n  }\n  .success-wrap-two .list-wrap li .icon {\n    font-size: 40px;\n    margin-right: 15px;\n  }\n  .success-wrap-two .list-wrap li .content .count {\n    font-size: 34px;\n  }\n  .about-img-seven-wrap img:nth-child(1) {\n    width: 390px;\n  }\n  .about-img-seven-wrap .experience-wrap .title {\n    font-size: 50px;\n  }\n  .about-img-seven-wrap .experience-wrap p {\n    font-size: 20px;\n  }\n  .about-img-seven-wrap .experience-wrap {\n    min-height: 370px;\n  }\n  .about-img-seven-wrap .shape {\n    left: 18%;\n  }\n  .about-content-eight .right-slide-img {\n    width: 40%;\n  }\n  .about-content-eight .about-content-inner .list-wrap li .icon {\n    width: 60px;\n    height: 60px;\n    font-size: 30px;\n    border-radius: 10px;\n    margin-right: 10px;\n  }\n  .about-content-eight .about-content-bottom {\n    gap: 30px 25px;\n  }\n  .about-content-eight .about-content-inner {\n    margin-bottom: 30px;\n  }\n  .choose-content-three {\n    margin-right: 0px;\n  }\n  .choose-img-three {\n    width: 45%;\n  }\n  .counter-item-wrap-four .counter-item-three {\n    padding: 28px 20px;\n  }\n  .counter-item-wrap-four .counter-icon {\n    font-size: 45px;\n    margin-right: 30px;\n  }\n  .counter-item-wrap-four .counter-content .count {\n    font-size: 32px;\n  }\n  .counter-item-wrap-four .counter-icon::after {\n    right: -15px;\n  }\n  .counter-item-wrap-four .counter-content p {\n    font-size: 14px;\n  }\n  .counter-content-four {\n    width: 100%;\n  }\n  .about-content-five.about-content-ten {\n    margin: 0;\n  }\n  .about-img-wrap-ten img:nth-child(2) {\n    left: 0;\n  }\n  .about-area-ten .about-shape-five img {\n    left: 41%;\n  }\n  .features-content-seven {\n    width: 100%;\n  }\n  .features-progress-wrap {\n    width: 100%;\n  }\n  .about-content-eleven {\n    width: 100%;\n  }\n  .about-img-wrap-eleven .shape-two {\n    left: -32px;\n    max-width: 115%;\n  }\n  .services-sidebar {\n    padding-right: 0;\n  }\n  .services-details-area .row .col-29 {\n    width: 32%;\n  }\n  .services-details-area .row .col-71 {\n    width: 68%;\n  }\n  .services-widget {\n    padding: 30px 20px 35px;\n  }\n  .services-details-content .title {\n    font-size: 30px;\n  }\n  .services-details-content .title-two {\n    font-size: 24px;\n  }\n  .services-cat-list .list-wrap li a {\n    padding: 15px 16px;\n  }\n  .sd-inner-wrap-two .row .col-58 {\n    width: 50%;\n  }\n  .sd-inner-wrap-two .row .col-42 {\n    width: 50%;\n  }\n  .services-details-list .list-wrap li {\n    margin-bottom: 30px;\n  }\n  .services-details-list .list-wrap li .icon {\n    width: 60px;\n    height: 60px;\n    border-radius: 10px;\n    font-size: 30px;\n    margin-right: 10px;\n  }\n  .services-details-list-two {\n    margin-right: 0;\n  }\n  .services-details-list-two .list-wrap li {\n    padding: 20px 15px;\n    display: block;\n  }\n  .services-details-list-two .list-wrap li .icon {\n    margin-right: 0;\n    margin-bottom: 10px;\n  }\n  .sd-inner-wrap-four .row .col-55 {\n    width: 50%;\n  }\n  .sd-inner-wrap-four .row .col-45 {\n    width: 50%;\n  }\n  .services-details-list-three .list-wrap li {\n    padding: 25px 20px;\n  }\n  .sd-inner-wrap-five .left-side-content {\n    margin-right: 0;\n  }\n  .project-details-wrap .row .col-29 {\n    width: 35%;\n  }\n  .project-details-wrap .row .col-71 {\n    width: 65%;\n  }\n  .project-details-info {\n    padding: 25px 20px 28px;\n  }\n  .project-details-thumb img {\n    min-height: 440px;\n    object-fit: cover;\n  }\n  .project-details-content .title {\n    font-size: 30px;\n  }\n  .project-details-content .title-two {\n    font-size: 24px;\n  }\n  .pd-inner-wrap .content {\n    margin-right: 0;\n  }\n  .pd-inner-wrap .row .col-41 {\n    width: 50%;\n  }\n  .pd-inner-wrap .row .col-59 {\n    width: 50%;\n  }\n  .team-details-info-wrap {\n    margin-right: 0;\n  }\n  .team-details-content > .title {\n    font-size: 30px;\n  }\n  .team-skill-wrap > .title-two {\n    font-size: 24px;\n  }\n  .blog-sidebar {\n    margin-left: 0;\n  }\n  .inner-blog-wrap .row .col-29 {\n    width: 32%;\n  }\n  .inner-blog-wrap .row .col-71 {\n    width: 68%;\n  }\n  .blog-widget {\n    padding: 25px 20px 30px;\n  }\n  .blog-post-thumb-two img {\n    min-height: 200px;\n    object-fit: cover;\n  }\n  .blog-details-wrap .row .col-29 {\n    width: 32%;\n  }\n  .blog-details-wrap .row .col-71 {\n    width: 68%;\n  }\n  .blog-details-content > .title {\n    font-size: 30px;\n  }\n  .blog-details-content blockquote {\n    margin: 50px 0 60px;\n    padding: 50px 100px 50px 35px;\n  }\n  .blog-details-content .title-two {\n    font-size: 24px;\n  }\n  .blog-avatar-wrap {\n    padding: 35px 25px;\n  }\n  .comment-respond {\n    padding: 35px 25px 50px;\n  }\n  .inner-contact-info {\n    padding-left: 40px;\n  }\n  .inner-contact-info .title {\n    font-size: 32px;\n  }\n  .contact-info-item {\n    margin-bottom: 30px;\n  }\n  .contact-map {\n    height: 400px;\n  }\n  .error-content .error-404 {\n    font-size: 300px;\n  }\n}\n\n/* Large devices (desktops, 992px and up) */\n@media (max-width: 991.98px) {\n  .container,\n  .custom-container {\n    max-width: 720px;\n  }\n  .menu-area {\n    padding: 18px 0;\n  }\n  .menu-nav {\n    justify-content: space-between;\n  }\n  .header-action {\n    margin-right: 30px;\n  }\n  .menu-outer .navbar-wrap {\n    display: block !important;\n  }\n  .menu-area .mobile-nav-toggler {\n    display: block;\n  }\n  .header-top-left .list-wrap li::before {\n    height: 25px;\n  }\n  .header-top-left .list-wrap {\n    justify-content: center;\n    margin-bottom: 10px;\n  }\n  .header-top-right {\n    justify-content: center;\n  }\n  .header-contact::before {\n    height: 25px;\n  }\n  .slider-content {\n    text-align: center;\n  }\n  .slider-content .sub-title::before {\n    left: 50%;\n    transform: translateX(-50%);\n  }\n  .slider-bg {\n    min-height: 620px;\n    padding: 210px 0 80px;\n    background-position: left center;\n  }\n  .about-img-wrap {\n    margin-bottom: 50px;\n  }\n  .section-title .title {\n    font-size: 34px;\n  }\n  .about-img-two {\n    margin-bottom: 50px;\n  }\n  .about-shape-wrap img:nth-child(1) {\n    right: auto;\n    left: 16%;\n  }\n  .about-list .list-wrap li {\n    font-size: 18px;\n  }\n  .success-wrap .list-wrap li .count {\n    font-size: 34px;\n  }\n  .project-top-content {\n    margin-left: 0;\n    margin-bottom: 40px;\n  }\n  .swiper-container.project-active {\n    margin-right: -285px;\n  }\n  .faq-bg-shape {\n    display: none;\n  }\n  .faq-img-wrap {\n    margin-bottom: 50px;\n  }\n  .faq-shape-wrap img:nth-child(2) {\n    display: none;\n  }\n  .request-content .title {\n    font-size: 28px;\n  }\n  .request-content {\n    text-align: center;\n    margin-bottom: 30px;\n  }\n  .request-content-right {\n    justify-content: center;\n  }\n  .team-thumb img {\n    width: 100%;\n  }\n  .testimonial-content {\n    text-align: center;\n  }\n  .testimonial-info span::before {\n    left: 50%;\n    transform: translateX(-50%);\n  }\n  .testimonial-nav {\n    justify-content: center;\n    left: calc(50% - 50px);\n  }\n  .contact-content {\n    margin-bottom: 50px;\n  }\n  .contact-bg {\n    background-position: left;\n  }\n  .footer-top .row [class*=\"col-\"]:nth-child(3) .footer-widget {\n    margin-left: 0;\n  }\n  .testimonial-img {\n    margin-bottom: 50px;\n  }\n  .header-style-two .heder-top-wrap {\n    display: none;\n  }\n  .header-style-two .menu-area {\n    padding: 0;\n  }\n  .header-style-two {\n    background: var(--tg-white);\n  }\n  .header-style-two .header-action > ul li.offcanvas-menu {\n    display: none;\n  }\n  .header-style-two .header-action ul > li > a {\n    border-right: 1px solid #d9d9d9;\n  }\n  .header-style-two .menu-area .mobile-nav-toggler {\n    margin-top: 20px;\n  }\n  .banner-content-two {\n    text-align: center;\n    margin-bottom: 50px;\n  }\n  .banner-content-two .banner-btn {\n    justify-content: center;\n  }\n  .banner-area-two .banner-img.text-center {\n    text-align: center !important;\n  }\n  .banner-area-two .banner-img img {\n    max-width: 350px;\n  }\n  .banner-shape-wrap img:nth-child(1) {\n    left: 21%;\n    bottom: 41%;\n  }\n  .banner-shape-wrap img:nth-child(2) {\n    right: auto;\n    left: 26%;\n  }\n  .banner-shape-wrap img:nth-child(3) {\n    right: 38%;\n    width: 386px;\n  }\n  .banner-bg-two {\n    padding: 150px 0 0;\n  }\n  .about-img-wrap-three .experience-wrap {\n    width: 90%;\n  }\n  .about-img-wrap-three img:nth-child(2) {\n    right: 0;\n  }\n  .about-img-wrap-three {\n    padding-bottom: 70px;\n    margin-bottom: 50px;\n  }\n  .about-shape-wrap-two img:nth-child(1) {\n    left: 14%;\n    bottom: auto;\n    top: 29%;\n  }\n  .about-shape-wrap-two img:nth-child(2) {\n    left: auto;\n    top: 2%;\n    right: 16%;\n  }\n  .section-title-two .title {\n    font-size: 34px;\n  }\n  .overview-img-wrap {\n    margin-bottom: 50px;\n  }\n  .content-bottom .list-wrap li {\n    min-width: 250px;\n  }\n  .content-bottom .list-wrap li .icon {\n    font-size: 45px;\n  }\n  .content-bottom .list-wrap li .content .count {\n    font-size: 34px;\n  }\n  .choose-content {\n    text-align: center;\n    margin-bottom: 50px;\n  }\n  .skill-wrap {\n    padding: 60px 60px;\n  }\n  .project-area-two .section-title-two {\n    text-align: center;\n    margin-bottom: 20px;\n  }\n  .project-content-top p {\n    text-align: center;\n  }\n  .cta-btn.text-end {\n    text-align: center !important;\n  }\n  .cta-content {\n    margin-bottom: 40px;\n    justify-content: center;\n  }\n  .cta-content .title {\n    font-size: 26px;\n  }\n  .cta-inner-wrap {\n    padding: 60px 30px;\n  }\n  .team-area-two .section-title-two {\n    text-align: center;\n    margin-bottom: 20px;\n  }\n  .section-top-content {\n    text-align: center;\n  }\n  .team-thumb-two img {\n    width: 100%;\n  }\n  .pricing-area-two .section-title-two {\n    text-align: center;\n    margin-bottom: 20px;\n  }\n  .blog-bg-two {\n    background-position: left;\n  }\n  .section-title-two p {\n    width: 80%;\n  }\n  .request-content-two {\n    text-align: center;\n    margin-bottom: 50px;\n  }\n  .request-content-two p {\n    width: 80%;\n    margin: 0 auto;\n  }\n  .footer-top-two .footer-info .list-wrap li .content p br {\n    display: none;\n  }\n  .banner-img-three {\n    text-align: center;\n  }\n  .banner-content-three {\n    margin-top: 50px;\n    text-align: center;\n  }\n  .banner-shape-wrap-three img:nth-child(2) {\n    right: 13%;\n    top: 39%;\n    bottom: auto;\n  }\n  .banner-img-three img.img-two {\n    left: 0%;\n  }\n  .banner-content-three .title {\n    font-size: 50px;\n  }\n  .banner-shape-wrap-three img:nth-child(1) {\n    right: auto;\n    bottom: auto;\n    top: 26%;\n    left: 10%;\n  }\n  .about-img-wrap-four {\n    margin-bottom: 50px;\n  }\n  .overview-img-two {\n    margin-bottom: 50px;\n  }\n  .counter-item-two::before {\n    display: none;\n  }\n  .team-thumb-three img {\n    width: 100%;\n  }\n  .team-thumb-three::before {\n    right: -88px;\n    bottom: -45px;\n    width: 250px;\n    height: 560px;\n    border-radius: 180px;\n  }\n  .testimonial-img-three {\n    display: none;\n  }\n  .testimonial-area-three .row .col-63 {\n    width: 100%;\n  }\n  .testimonial-item-wrap-three {\n    padding: 40px 40px;\n  }\n  .testimonial-item-wrap-three .testimonial-info span::before {\n    left: 0;\n    transform: translateX(0);\n  }\n  .cta-inner-wrap-two {\n    padding: 60px 30px;\n  }\n  .header-style-three .offcanvas-menu.offcanvas-menu-two {\n    display: none;\n  }\n  .header-style-three .menu-area .mobile-nav-toggler {\n    margin-top: -1px;\n  }\n  .header-style-four .header-top-right {\n    display: none;\n  }\n  .header-style-four .header-top-left .list-wrap {\n    margin-bottom: 0;\n  }\n  .header-style-four .heder-top-wrap {\n    padding: 15px 0;\n  }\n  .header-style-four .offcanvas-menu.offcanvas-menu-two {\n    display: none;\n  }\n  .header-style-four .menu-area .mobile-nav-toggler {\n    margin-top: -1px;\n  }\n  .banner-shape-wrap-four img:nth-child(3) {\n    right: 16%;\n    width: 300px;\n  }\n  .banner-shape-wrap-four img:nth-child(2) {\n    right: auto;\n    left: 10%;\n    bottom: auto;\n    top: 27%;\n  }\n  .banner-content-four {\n    margin-top: 50px;\n    text-align: center;\n  }\n  .banner-bg-four {\n    padding: 60px 0 140px;\n  }\n  .about-shape-five img {\n    left: auto;\n    right: 18%;\n    bottom: auto;\n    top: 33%;\n  }\n  .about-img-wrap-five {\n    margin-bottom: 50px;\n  }\n  .choose-content-two {\n    text-align: center;\n    margin-top: 50px;\n  }\n  .choose-circle-wrap {\n    justify-content: center;\n  }\n  .estimate-content {\n    margin-bottom: 50px;\n  }\n  .team-thumb-four img {\n    width: 100%;\n  }\n  .testimonial-img-four::before {\n    left: 11.2%;\n  }\n  .testimonial-img-four {\n    margin-bottom: 50px;\n  }\n  .pricing-area-three .section-title-two {\n    text-align: center;\n    margin-bottom: 30px;\n  }\n  .banner-content-five {\n    text-align: center;\n    margin-top: 50px;\n  }\n  .about-img-six img:nth-child(2) {\n    bottom: -7%;\n  }\n  .about-img-six {\n    margin-bottom: 50px;\n  }\n  .project-thumb-four > img {\n    min-height: 290px;\n    width: 100%;\n    object-fit: cover;\n  }\n  .testimonial-content-five .testimonial-content {\n    text-align: left;\n  }\n  .testimonial-img-five {\n    margin-bottom: 50px;\n  }\n  .about-img-seven-wrap {\n    margin-bottom: 50px;\n  }\n  .success-wrap-two .list-wrap li {\n    padding: 30px 25px;\n    min-width: 240px;\n  }\n  .success-wrap-two .list-wrap li .icon {\n    font-size: 45px;\n  }\n  .success-wrap-two .list-wrap li .content .count {\n    font-size: 36px;\n  }\n  .breadcrumb-bg {\n    padding: 90px 0 100px;\n  }\n  .breadcrumb-content .title {\n    font-size: 40px;\n  }\n  .brand-area-six {\n    padding: 60px 0;\n  }\n  .about-img-eight {\n    margin-bottom: 50px;\n  }\n  .about-content-eight .right-slide-img {\n    width: auto;\n  }\n  .about-content-eight .about-content-inner {\n    margin-bottom: 40px;\n  }\n  .choose-img-three {\n    display: none;\n  }\n  .about-content-eight .about-content-inner .list-wrap li .icon {\n    width: 80px;\n    height: 80px;\n    font-size: 40px;\n    margin-right: 15px;\n  }\n  .counter-item-wrap-four .counter-item-three {\n    padding: 28px 30px;\n  }\n  .counter-item-wrap-four .counter-icon {\n    font-size: 60px;\n    margin-right: 40px;\n  }\n  .counter-item-wrap-four .counter-content .count {\n    font-size: 36px;\n  }\n  .counter-item-wrap-four .counter-content p {\n    font-size: 16px;\n  }\n  .counter-item-wrap-four .counter-icon::after {\n    right: -20px;\n  }\n  .counter-content-four {\n    margin-bottom: 50px;\n  }\n  .about-img-wrap-ten {\n    padding-left: 25px;\n  }\n  .about-area-ten .about-shape-five img {\n    left: 16%;\n  }\n  .features-content-seven {\n    margin-bottom: 50px;\n  }\n  .about-content-eleven {\n    margin-top: 50px;\n  }\n  .section-title .title br {\n    display: none;\n  }\n  .about-content-six {\n    margin-top: 50px;\n  }\n  .services-area-six .section-title-two {\n    text-align: center;\n    margin-bottom: 30px;\n  }\n  .services-details-area .row .col-71 {\n    width: 100%;\n  }\n  .services-details-area .row .col-29 {\n    width: 70%;\n  }\n  .services-sidebar {\n    margin-top: 120px;\n  }\n  .services-widget {\n    padding: 30px 30px 35px;\n  }\n  .brand-area-seven {\n    padding: 50px 0;\n  }\n  .sd-inner-wrap-two .row .col-42 {\n    width: 45%;\n  }\n  .sd-inner-wrap-two .row .col-58 {\n    width: 55%;\n  }\n  .services-details-list-two .list-wrap li {\n    padding: 20px;\n  }\n  .sd-inner-wrap-four .row .col-55 {\n    width: 100%;\n  }\n  .sd-inner-wrap-four .thumb {\n    margin-bottom: 30px;\n  }\n  .sd-inner-wrap-four .thumb img {\n    width: 100%;\n    max-height: 400px;\n    object-fit: cover;\n  }\n  .sd-inner-wrap-four .row .col-45 {\n    width: 100%;\n  }\n  .services-details-list-three .list-wrap li .content .title {\n    font-size: 20px;\n  }\n  .project-details-wrap .row .col-71 {\n    width: 100%;\n  }\n  .project-details-wrap .row .col-29 {\n    width: 100%;\n  }\n  .project-details-info {\n    padding: 25px 35px 28px;\n  }\n  .pd-inner-wrap .row .col-41 {\n    width: 100%;\n  }\n  .pd-inner-wrap .row .col-59 {\n    width: 100%;\n  }\n  .pd-inner-wrap .content {\n    margin-bottom: 30px;\n  }\n  .team-details-info-wrap {\n    margin-bottom: 50px;\n  }\n  .team-details-thumb {\n    text-align: center;\n  }\n  .inner-blog-wrap .row .col-71 {\n    width: 100%;\n  }\n  .blog-post-thumb-two img {\n    min-height: 230px;\n  }\n  .inner-blog-wrap .row .col-29 {\n    width: 70%;\n  }\n  .blog-sidebar {\n    margin-top: 120px;\n  }\n  .blog-widget {\n    padding: 25px 30px 30px;\n  }\n  .blog-details-wrap .row .col-29 {\n    width: 70%;\n  }\n  .blog-details-wrap .row .col-71 {\n    width: 100%;\n  }\n  .inner-contact-img {\n    text-align: center;\n    margin-bottom: 50px;\n  }\n  .inner-contact-info {\n    padding-left: 0;\n  }\n}\n\n/* Medium devices (tablets, 768px and up) */\n@media (max-width: 767.98px) {\n  .custom-container {\n    max-width: 100%;\n  }\n  .transparent-header {\n    top: 0;\n  }\n  .header-spacer {\n    height: 70px !important;\n  }\n  .about-area-two::before {\n    display: none;\n  }\n  .header-top-left {\n    display: none;\n  }\n  .menu-area {\n    padding: 20px 0;\n  }\n  .menu-area .mobile-nav-toggler {\n    margin-top: -6px;\n  }\n  .slider-content .title {\n    font-size: 42px;\n  }\n  .slider-bg {\n    min-height: 550px;\n    padding: 180px 0 80px;\n  }\n  .about-img-wrap img.main-img {\n    width: 260px;\n    height: 260px;\n  }\n  .about-bg {\n    padding: 100px 0 180px;\n  }\n  .section-title .title {\n    font-size: 32px;\n  }\n  .about-img-two img:nth-child(2) {\n    display: none;\n  }\n  .about-img-two .main-img img {\n    border-radius: 15px;\n    border: 6px solid var(--tg-white);\n    width: 100%;\n  }\n  .about-area-two {\n    padding: 90px 0 100px;\n  }\n  .about-img-two {\n    padding-left: 0;\n  }\n  .about-shape-wrap img:nth-child(1) {\n    display: none;\n  }\n  .about-list .list-wrap li {\n    width: 100%;\n  }\n  .success-wrap .list-wrap li {\n    width: 100%;\n  }\n  .success-wrap .list-wrap {\n    flex-wrap: wrap;\n    gap: 30px;\n  }\n  .about-area-two {\n    padding: 70px 0 100px;\n  }\n  .services-thumb img {\n    width: 100%;\n  }\n  .services-item {\n    padding: 25px 20px 35px;\n  }\n  .section-title .title br {\n    display: none;\n  }\n  .services-bg {\n    padding: 100px 0;\n  }\n  .counter-bg {\n    padding: 100px 0 70px;\n  }\n  .counter-item .count {\n    font-size: 45px;\n  }\n  .project-bg {\n    padding: 100px 0 70px;\n  }\n  .swiper-container.project-active {\n    margin-right: 0;\n  }\n  .project-thumb img {\n    width: 100%;\n  }\n  .project-content {\n    margin: -85px 15px 0;\n    padding: 22px 70px 22px 18px;\n  }\n  .project-content .title {\n    font-size: 20px;\n  }\n  .faq-img-wrap img:nth-child(2) {\n    bottom: 27%;\n    width: 180px;\n  }\n  .faq-content .accordion-button {\n    padding: 17px 50px 17px 20px;\n  }\n  .faq-content .accordion-body {\n    padding: 20px 20px 30px;\n  }\n  .faq-area {\n    padding: 0 0 100px;\n  }\n  .request-content .title {\n    font-size: 25px;\n  }\n  .request-content-right {\n    flex-wrap: wrap;\n  }\n  .team-bg {\n    padding: 100px 0 70px;\n  }\n  .testimonial-img .review-wrap {\n    max-width: 150px;\n    border-radius: 10px;\n    padding: 10px 10px 10px;\n    left: 0;\n  }\n  .testimonial-img .review-wrap img {\n    margin-bottom: 10px;\n  }\n  .testimonial-img .review-wrap .content .title {\n    font-size: 30px;\n  }\n  .testimonial-nav {\n    bottom: 24px;\n  }\n  .testimonial-bg {\n    padding: 100px 0;\n    background-position: center;\n  }\n  .pricing-area {\n    padding: 100px 0 70px;\n  }\n  .section-title.text-center.mb-60 {\n    margin-bottom: 40px;\n  }\n  .contact-bg {\n    padding: 100px 0;\n  }\n  .blog-post-area {\n    padding: 100px 0 70px;\n  }\n  .brand-aera {\n    padding-bottom: 80px;\n  }\n  .footer-top {\n    padding: 80px 0 30px;\n  }\n  .footer-bottom {\n    padding: 20px 0;\n  }\n  .footer-bottom .left-sider {\n    text-align: center;\n    margin-bottom: 15px;\n  }\n  .footer-social .list-wrap {\n    justify-content: center;\n  }\n  .footer-social .list-wrap li a {\n    width: 40px;\n    height: 40px;\n    font-size: 16px;\n  }\n  .scroll-top {\n    right: 15px;\n  }\n  .section-title p br {\n    display: none;\n  }\n  .testimonial-nav-two {\n    display: none;\n  }\n  .header-style-two .header-action ul > li > a {\n    padding: 0;\n    border: none;\n  }\n  .header-style-two .header-action > ul li::before {\n    display: none;\n  }\n  .search-wrap .title {\n    font-size: 34px;\n    margin: 0 0 30px 0;\n  }\n  .search-form input {\n    padding: 10px 30px 10px;\n    font-size: 20px;\n  }\n  .search-btn {\n    right: 10px;\n    font-size: 20px;\n  }\n  .search-form input::placeholder {\n    font-size: 20px;\n  }\n  .banner-area-two .banner-img img {\n    max-width: 100%;\n  }\n  .banner-shape-wrap img:nth-child(3) {\n    display: none;\n  }\n  .banner-shape-wrap img:nth-child(2) {\n    left: 9%;\n  }\n  .banner-shape-wrap img:nth-child(1) {\n    left: 21%;\n    bottom: 37%;\n  }\n  .banner-content-two .title {\n    font-size: 42px;\n  }\n  .about-img-wrap-three img:nth-child(1) {\n    border-radius: 40px 0 0 0;\n    max-width: 100%;\n  }\n  .about-img-wrap-three img:nth-child(2) {\n    display: none;\n  }\n  .about-img-wrap-three .experience-wrap {\n    width: 100%;\n    padding: 30px 30px 30px 20px;\n  }\n  .about-shape-wrap-two img:nth-child(1) {\n    display: none;\n  }\n  .section-title-two .title {\n    font-size: 32px;\n  }\n  .about-author-info .signature {\n    display: none;\n  }\n  .about-shape-wrap-two img:nth-child(3) {\n    width: 300px;\n  }\n  .services-area-two .section-title-two {\n    text-align: center;\n    margin-bottom: 30px;\n  }\n  .services-area-two .view-all-btn {\n    text-align: center !important;\n  }\n  .overview-img-wrap img:nth-child(2) {\n    display: none;\n  }\n  .overview-img-wrap .icon {\n    display: none;\n  }\n  .overview-img-wrap img:nth-child(3) {\n    display: none;\n  }\n  .overview-img-wrap img:nth-child(1) {\n    border-radius: 130px;\n  }\n  .skill-wrap {\n    padding: 40px 20px;\n  }\n  .skill-wrap .section-title-two .title {\n    font-size: 30px;\n  }\n  .section-title-two .title br {\n    display: none;\n  }\n  .project-thumb-two img {\n    width: 100%;\n  }\n  .cta-content {\n    display: block;\n    text-align: center;\n  }\n  .cta-info-wrap {\n    width: 100%;\n    margin-bottom: 25px;\n    justify-content: center;\n  }\n  .cta-info-wrap::before {\n    display: none;\n  }\n  .testimonial-item-wrap-two {\n    padding: 0 0px;\n  }\n  .testimonial-item-two {\n    padding: 30px 20px;\n  }\n  .testimonial-avatar .avatar-info .title {\n    font-size: 20px;\n  }\n  .testimonial-content-two > p {\n    font-size: 18px;\n  }\n  .section-title-two p {\n    width: 100%;\n  }\n  .features-item-two {\n    display: block;\n    text-align: center;\n  }\n  .features-icon-two {\n    margin: 0 auto 20px;\n  }\n  .services-bg-two {\n    padding: 100px 0 70px;\n  }\n  .overview-area {\n    padding: 100px 0;\n  }\n  .choose-bg {\n    padding: 100px 0;\n  }\n  .project-bg-two {\n    padding: 100px 0 180px;\n  }\n  .team-area-two {\n    padding: 100px 0 70px;\n  }\n  .testimonial-bg-two {\n    padding: 100px 0;\n  }\n  .pricing-area-two {\n    padding: 100px 0 70px;\n  }\n  .blog-bg-two {\n    padding: 100px 0 70px;\n  }\n  .request-area-two {\n    padding: 100px 0;\n  }\n  .footer-top-two {\n    padding: 80px 0 30px;\n  }\n  .request-content-two p {\n    width: 100%;\n  }\n  .header-style-three .header-action .header-contact-two {\n    display: none;\n  }\n  .header-style-three .menu-area .mobile-nav-toggler {\n    margin-top: -5px;\n  }\n  .banner-img-three img.main-img {\n    max-width: 100%;\n  }\n  .banner-img-three img.img-three {\n    display: none;\n  }\n  .banner-img-three img.img-two {\n    display: none;\n  }\n  .banner-area-three::after,\n  .banner-area-three::before {\n    display: none;\n  }\n  .overview-area-two::before {\n    display: none;\n  }\n  .banner-area-three {\n    padding: 110px 0 60px;\n  }\n  .banner-shape-wrap-three img:nth-child(1) {\n    display: none;\n  }\n  .banner-shape-wrap-three img:nth-child(2) {\n    display: none;\n  }\n  .banner-content-three .title {\n    font-size: 42px;\n  }\n  .features-area-three {\n    padding: 100px 0 70px;\n  }\n  .about-img-wrap-four .img-two {\n    display: none;\n  }\n  .about-shape-wrap-three img:nth-child(1) {\n    display: none;\n  }\n  .about-shape-wrap-three img:nth-child(3) {\n    right: 22%;\n    top: -7%;\n  }\n  .about-img-wrap-four .icon {\n    width: 80px;\n    height: 80px;\n    left: -2%;\n    top: 3%;\n    font-size: 32px;\n  }\n  .about-area-four {\n    padding: 0 0 100px;\n  }\n  .overview-img-two .img-two {\n    display: none;\n  }\n  .overview-area-two {\n    padding: 0 0 100px;\n  }\n  .project-area-three .section-title-two {\n    text-align: center;\n  }\n  .view-all-btn.text-end {\n    text-align: center !important;\n  }\n  .project-thumb-three img {\n    width: 100%;\n  }\n  .project-area-three {\n    padding: 0 0 70px;\n  }\n  .team-area-three {\n    padding: 100px 0 70px;\n  }\n  .team-thumb-three::before {\n    right: -32%;\n    bottom: -12%;\n    width: 80%;\n    height: 160%;\n    border-radius: 180px;\n  }\n  .testimonial-item-wrap-three {\n    padding: 30px;\n  }\n  .testimonial-nav-three {\n    display: none;\n  }\n  .cta-area-two {\n    padding: 100px 0 0;\n  }\n  .blog-area-three {\n    padding: 100px 0 70px;\n  }\n  .footer-top-three {\n    padding: 90px 0 30px;\n  }\n  .testimonial-img-four {\n    padding-left: 0;\n    text-align: center;\n  }\n  .testimonial-img-four::before {\n    width: 320px;\n    height: 320px;\n    left: 50%;\n    transform: translateX(-50%);\n  }\n  .testimonial-img-four .icon {\n    display: none;\n  }\n  .header-style-four .heder-top-wrap {\n    display: none;\n  }\n  .header-style-four .header-contact-two {\n    display: none;\n  }\n  .header-style-four .menu-area .mobile-nav-toggler {\n    margin-top: -6px;\n  }\n  .about-content-five .about-content-bottom {\n    flex-wrap: wrap;\n  }\n  .banner-shape-wrap-four img:nth-child(3) {\n    width: 200px;\n  }\n  .banner-shape-wrap-four img:nth-child(2) {\n    display: none;\n  }\n  .banner-bg-four {\n    padding: 50px 0 140px;\n  }\n  .banner-content-four .title {\n    font-size: 42px;\n  }\n  .banner-shape-wrap-four img:nth-child(1) {\n    display: none;\n  }\n  .features-item-four {\n    display: block;\n    text-align: center;\n  }\n  .features-icon-four {\n    width: 80px;\n    height: 80px;\n    margin: 0 auto 20px;\n  }\n  .features-icon-four::before {\n    right: auto;\n    left: 50%;\n    bottom: 0;\n    top: auto;\n    transform: translateX(-50%);\n    width: 16px;\n    height: 3px;\n  }\n  .about-img-wrap-five img:nth-child(2) {\n    display: none;\n  }\n  .about-img-wrap-five::before {\n    display: none;\n  }\n  .about-img-wrap-five .experience-wrap {\n    max-width: 165px;\n    padding: 20px 20px;\n  }\n  .about-img-wrap-five .experience-wrap .title {\n    font-size: 42px;\n  }\n  .about-img-wrap-five .experience-wrap .title span {\n    font-size: 20px;\n  }\n  .about-img-wrap-five {\n    padding-bottom: 0px;\n  }\n  .about-content-five .about-list {\n    width: 100%;\n    margin-bottom: 30px;\n  }\n  .services-area-three .section-title-two {\n    text-align: center;\n    margin-bottom: 30px;\n  }\n  .cta-info-wrap.cta-info-wrap-two .icon {\n    width: 60px;\n    height: 60px;\n    font-size: 30px;\n  }\n  .testimonial-item-wrap-four {\n    padding-right: 0;\n  }\n  .testimonial-nav-four {\n    display: none;\n  }\n  .testimonial-content-four > p {\n    font-size: 20px;\n    margin-bottom: 22px;\n  }\n  .testimonial-content-four .rating {\n    margin-bottom: 25px;\n  }\n  .about-area-five {\n    padding: 100px 0;\n  }\n  .brand-item-wrap-two {\n    padding: 50px 0;\n  }\n  .services-area-three {\n    padding: 100px 0 70px;\n  }\n  .choose-area-two {\n    padding: 100px 0 180px;\n  }\n  .estimate-area {\n    padding: 100px 0 0;\n  }\n  .team-area-four {\n    padding: 100px 0 70px;\n  }\n  .testimonial-bg-four {\n    padding: 100px 0;\n  }\n  .pricing-area-three {\n    padding: 100px 0 70px;\n  }\n  .blog-area-four {\n    padding: 100px 0 70px;\n  }\n  .testimonial-img-four .shape {\n    left: 50%;\n    transform: translatex(-50%);\n  }\n  .header-style-five .header-action {\n    display: none;\n  }\n  .banner-img-five .main-img {\n    max-width: 100%;\n    width: 100%;\n  }\n  .banner-img-five .shape-two {\n    width: 90px;\n  }\n  .banner-img-five .shape-three {\n    width: 50px;\n    right: 16%;\n    top: 9%;\n  }\n  .banner-img-five .shape-one {\n    width: 150px;\n    right: 0;\n  }\n  .banner-content-five .title {\n    font-size: 42px;\n  }\n  .banner-area-five::after {\n    display: none;\n  }\n  .banner-content-five {\n    margin-top: 30px;\n  }\n  .testimonial-content-five {\n    padding-right: 0;\n  }\n  .testimonial-nav-five {\n    display: none;\n  }\n  .project-area-four .section-title {\n    text-align: center;\n    margin-bottom: 30px;\n  }\n  .project-area-four .section-title .sub-title::before {\n    left: 50%;\n    transform: translateX(-50%);\n  }\n  .services-area-four {\n    padding: 100px 0 70px;\n  }\n  .about-area-six {\n    padding: 0 0 100px;\n  }\n  .counter-area-three {\n    padding: 0 0 70px;\n  }\n  .team-area-five {\n    padding: 0 0 70px;\n  }\n  .project-area-four {\n    padding: 100px 0 170px;\n  }\n  .testimonial-area-five {\n    padding: 100px 0;\n  }\n  .blog-area-five {\n    padding: 0 0 70px;\n  }\n  .breadcrumb-shape-wrap img:nth-child(2) {\n    display: none;\n  }\n  .about-img-seven-wrap .experience-wrap {\n    display: none;\n  }\n  .about-img-seven-wrap img:nth-child(2) {\n    display: none;\n  }\n  .about-img-seven-wrap img:nth-child(1) {\n    width: auto;\n  }\n  .about-img-seven-wrap {\n    padding-bottom: 0;\n  }\n  .about-area-seven {\n    padding: 100px 0;\n  }\n  .features-bg {\n    padding: 100px 0 60px;\n  }\n  .about-img-seven-wrap {\n    text-align: center;\n  }\n  .breadcrumb-content .title {\n    font-size: 38px;\n  }\n  .breadcrumb-shape-wrap img:nth-child(1) {\n    width: 300px;\n  }\n  .about-content-eight .about-content-inner .list-wrap {\n    width: 100%;\n  }\n  .about-content-eight .about-content-inner .list-wrap li .icon {\n    width: 70px;\n    height: 70px;\n    font-size: 35px;\n  }\n  .about-content-eight .right-slide-img {\n    margin: 30px 0 0;\n  }\n  .about-area-eight {\n    padding: 100px 0;\n  }\n  .choose-area-three {\n    padding: 100px 0;\n  }\n  .accordion-wrap-two .accordion-button {\n    padding: 16px 50px 16px 22px;\n  }\n  .accordion-wrap-two .accordion-body {\n    padding: 20px 30px 30px 22px;\n  }\n  .testimonial-area-six {\n    padding: 100px 0 0;\n  }\n  .about-area-nine {\n    padding: 100px 0;\n  }\n  .counter-area-four {\n    padding: 200px 0 100px;\n  }\n  .counter-item-wrap-four .list-wrap li {\n    width: 100%;\n  }\n  .about-area-ten {\n    padding: 100px 0;\n  }\n  .about-content-ten .about-success-wrap .list-wrap {\n    flex-wrap: wrap;\n  }\n  .features-area-seven {\n    padding: 210px 0 100px;\n  }\n  .about-img-wrap-ten {\n    padding-left: 0;\n  }\n  .about-area-eleven {\n    padding: 100px 0 0;\n  }\n  .about-area-six {\n    padding: 100px 0 100px;\n  }\n  .team-area-six {\n    padding: 200px 0 70px;\n  }\n  .inner-services-bg {\n    padding: 100px 0 70px;\n  }\n  .services-thumb img {\n    width: 100%;\n  }\n  .services-area-six {\n    padding: 100px 0 70px;\n  }\n  .services-area-seven {\n    padding: 100px 0 70px;\n  }\n  .services-details-thumb img {\n    min-height: 250px;\n    object-fit: cover;\n  }\n  .services-details-content .title {\n    font-size: 26px;\n  }\n  .sd-inner-wrap .row .col-56 {\n    width: 100%;\n  }\n  .sd-inner-wrap .row .col-44 {\n    width: 100%;\n  }\n  .sd-inner-wrap .thumb {\n    margin-top: 30px;\n  }\n  .sd-inner-wrap .content .list-wrap li {\n    width: 100%;\n  }\n  .accordion-wrap-three .accordion-button {\n    padding: 16px 45px 16px 20px;\n    font-size: 18px;\n  }\n  .accordion-wrap-three .accordion-body {\n    padding: 20px 35px 30px 20px;\n  }\n  .services-details-area .row .col-29 {\n    width: 100%;\n  }\n  .services-widget {\n    padding: 30px 25px 35px;\n  }\n  .services-sidebar {\n    margin-top: 100px;\n  }\n  .services-details-area {\n    padding: 100px 0;\n  }\n  .sd-inner-wrap-two .row .col-58 {\n    width: 100%;\n  }\n  .sd-inner-wrap-two .thumb img {\n    width: 100%;\n  }\n  .sd-inner-wrap-two .row .col-42 {\n    width: 100%;\n  }\n  .services-details-list {\n    margin-top: 30px;\n  }\n  .industrial-working-wrap img {\n    width: 100%;\n  }\n  .sd-inner-wrap-three .col-57 {\n    width: 100%;\n  }\n  .sd-inner-wrap-three .col-43 {\n    width: 100%;\n  }\n  .services-details-list-two {\n    margin-bottom: 30px;\n  }\n  .services-details-list-three .list-wrap {\n    flex-wrap: wrap;\n  }\n  .services-details-list-three .list-wrap li {\n    display: block;\n  }\n  .services-details-list-three .list-wrap li .icon {\n    margin-right: 0;\n    margin-bottom: 15px;\n  }\n  .services-details-thumb-two img {\n    width: 100%;\n    min-height: 250px;\n    object-fit: cover;\n  }\n  .sd-inner-wrap-five .row .col-50 {\n    width: 100%;\n  }\n  .sd-inner-wrap-five .left-side-content {\n    margin-bottom: 30px;\n  }\n  .project-details-area {\n    padding: 100px 0;\n  }\n  .project-details-thumb img {\n    min-height: 250px;\n  }\n  .project-details-info {\n    padding: 25px 25px 28px;\n  }\n  .project-details-content .title {\n    font-size: 26px;\n  }\n  .pd-optimized-wrap {\n    margin-top: 40px;\n    margin-bottom: 50px;\n  }\n  .pd-inner-wrap .content .list-wrap li {\n    width: 100%;\n  }\n  .pd-inner-wrap .thumb img {\n    min-height: 250px;\n    object-fit: cover;\n    width: 100%;\n  }\n  .team-details-area {\n    padding: 100px 0;\n  }\n  .team-details-content > .title {\n    font-size: 26px;\n  }\n  .inner-blog-wrap .row .col-29 {\n    width: 100%;\n  }\n  .blog-widget {\n    padding: 25px 25px 30px;\n  }\n  .blog-area {\n    padding: 100px 0;\n  }\n  .blog-sidebar {\n    margin-top: 100px;\n  }\n  .blog-details-thumb img {\n    width: 100%;\n    min-height: 250px;\n    object-fit: cover;\n  }\n  .blog-details-content > .title {\n    font-size: 26px;\n  }\n  .blog-details-content blockquote {\n    margin: 40px 0 50px;\n    padding: 40px 30px 40px 30px;\n  }\n  .blog-details-content blockquote::after {\n    font-size: 40px;\n    right: 16px;\n    top: 16px;\n  }\n  .bd-inner-wrap .row .col-46 {\n    width: 100%;\n  }\n  .bd-inner-wrap .thumb {\n    margin-bottom: 30px;\n  }\n  .bd-inner-wrap .row .col-54 {\n    width: 100%;\n  }\n  .bd-content-bottom .blog-post-share {\n    justify-content: flex-start;\n    margin-top: 15px;\n  }\n  .blog-avatar-wrap {\n    padding: 30px 25px;\n    display: block;\n  }\n  .blog-avatar-img {\n    margin-right: 0;\n    margin-bottom: 20px;\n  }\n  .comments-box {\n    display: block;\n  }\n  .comments-avatar {\n    margin-right: 0;\n    margin-bottom: 20px;\n  }\n  .latest-comments .children {\n    margin: 0;\n  }\n  .comment-form .checkbox-grp {\n    align-items: flex-start;\n  }\n  .blog-details-wrap .row .col-29 {\n    width: 100%;\n  }\n  .blog-details-area {\n    padding: 100px 0;\n  }\n  .inner-contact-area {\n    padding: 100px 0;\n  }\n  .inner-contact-info .title {\n    font-size: 28px;\n  }\n  .contact-map {\n    height: 350px;\n  }\n  .error-content .error-404 {\n    font-size: 150px;\n  }\n  .error-content .title {\n    font-size: 30px;\n  }\n  .error-content p br {\n    display: none;\n  }\n  .error-area {\n    padding: 100px 0;\n  }\n}\n\n/* Small devices (landscape phones, 576px and up) */\n@media only screen and (min-width: 576px) and (max-width: 767px) {\n  .container,\n  .custom-container {\n    max-width: 540px;\n  }\n  .slider-content .title {\n    font-size: 45px;\n  }\n  .about-img-wrap img.main-img {\n    width: 314px;\n    height: 314px;\n  }\n  .about-list .list-wrap li {\n    width: 50%;\n  }\n  .success-wrap .list-wrap {\n    gap: 0;\n  }\n  .success-wrap .list-wrap li {\n    width: 50%;\n  }\n  .services-content .content-top .title {\n    font-size: 24px;\n  }\n  .services-item {\n    padding: 25px 30px 35px;\n  }\n  .swiper-container.project-active {\n    margin-right: -200px;\n  }\n  .blog-post-content {\n    padding: 25px 30px 30px;\n  }\n  .blog-post-content .title {\n    font-size: 22px;\n  }\n  .banner-content-two .title {\n    font-size: 45px;\n  }\n  .banner-area-two .banner-img img {\n    max-width: 320px;\n  }\n  .banner-shape-wrap img:nth-child(1) {\n    left: 21%;\n    bottom: 42%;\n  }\n  .content-bottom .list-wrap li {\n    min-width: 240px;\n  }\n  .skill-wrap {\n    padding: 40px 40px;\n  }\n  .project-content-two .title {\n    font-size: 26px;\n  }\n  .testimonial-item-two {\n    padding: 30px 30px;\n  }\n  .blog-post-content-two {\n    padding: 35px 25px;\n  }\n  .blog-post-content-two .title {\n    font-size: 24px;\n  }\n  .banner-content-three .title {\n    font-size: 45px;\n  }\n  .testimonial-item-wrap-three {\n    padding: 40px;\n  }\n  .banner-content-four .title {\n    font-size: 45px;\n  }\n  .about-img-wrap-five {\n    text-align: center;\n  }\n  .about-shape-five img {\n    right: 8%;\n  }\n  .banner-img-five .shape-one {\n    width: 240px;\n  }\n  .banner-img-five .shape-three {\n    width: 60px;\n    right: 23%;\n    top: 20%;\n  }\n  .banner-content-five .title {\n    font-size: 45px;\n  }\n  .counter-icon {\n    font-size: 48px;\n  }\n  .counter-item-three {\n    padding: 28px 20px;\n  }\n  .about-content-eight .about-content-inner .list-wrap {\n    width: 62%;\n  }\n  .about-content-eight .right-slide-img {\n    margin: 0 0 0 auto;\n    width: 36%;\n  }\n  .counter-item-wrap-four .list-wrap li {\n    width: 50%;\n  }\n  .about-area-ten .about-shape-five img {\n    left: auto;\n    right: 9%;\n  }\n  .services-details-content .title-two {\n    font-size: 26px;\n  }\n  .services-details-content .title {\n    font-size: 28px;\n  }\n  .services-details-list .list-wrap li .icon {\n    width: 70px;\n    height: 70px;\n    margin-right: 20px;\n  }\n  .services-details-list-two .list-wrap li {\n    padding: 25px 30px;\n    display: flex;\n  }\n  .services-details-list-two .list-wrap li .icon {\n    margin-right: 10px;\n    margin-bottom: 0;\n  }\n  .sd-inner-wrap-four .thumb img {\n    max-height: 360px;\n  }\n  .project-details-content .title {\n    font-size: 28px;\n  }\n  .team-details-content > .title {\n    font-size: 28px;\n  }\n  .blog-details-content > .title {\n    font-size: 28px;\n  }\n  .comment-form .checkbox-grp input {\n    margin-top: 5px;\n  }\n  .comment-respond {\n    padding: 35px 30px 50px;\n  }\n  .blog-widget {\n    padding: 25px 30px 30px;\n  }\n  .blog-avatar-wrap {\n    padding: 30px 30px;\n  }\n  .inner-contact-info .title {\n    font-size: 30px;\n  }\n  .error-content .error-404 {\n    font-size: 200px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
